export default {
  l: {
    add: "إضافة",
    addCashDesk: "إضافة صندوق نقدي",
    addChannel: "إضافة قناة",
    addCity: "إضافة مدينة",
    addChannelClientCompositionMapping: "إضافة تعيين تكوين عميل القناة",
    addChannelHotelRateCodeMapping: "إضافة تعيين رمز سعر فندق القناة",
    addChannelHotelRoomTypeMapping: "إضافة تعيين نوع غرفة فندق القناة",
    addCountry: "إضافة دولة",
    addCreditCardType: "إضافة نوع بطاقة ائتمان",
    addGeneralJournal: "إضافة دفتر يومية عام",
    addJournalAccountType: "إضافة نوع حساب دفتر اليومية",
    addJournalBatch: "إضافة دفعة دفتر اليومية",
    addJournalTemplate: "إضافة قالب دفتر اليومية",
    addRoomStatus: "إضافة حالة الغرفة",
    addRoomType: "إضافة نوع الغرفة",
    adminCode: "رمز المسؤول",
    adminName: "اسم المسؤول",
    adminNameAscii: "اسم المسؤول ASCII",
    adminType: "نوع المسؤول",
    amountAfterDiscount: "المبلغ بعد الخصم",
    backOffice: "المكتب الخلفي",
    bankAccount: "حساب بنكي",
    bankAccountId: "معرف الحساب البنكي",
    bookingSource: "مصدر الحجز",
    cancel: "إلغاء",
    capital: "العاصمة",
    cashDesk: "صندوق نقدي",
    channel: "قناة",
    channelAgencyCode: "رمز وكالة القناة",
    channelClientCompositionMapping: "تعيين تكوين عميل القناة",
    channelHotelRateCodeMapping: "تعيين رمز سعر فندق القناة",
    channelHotelRoomTypeMapping: "تعيين نوع غرفة فندق القناة",
    channelId: "معرف القناة",
    channelManager: "مدير القناة",
    channelRateCode: "رمز سعر القناة",
    channelRoomType: "نوع غرفة القناة",
    channelRoomTypeCode: "رمز نوع غرفة القناة",
    city: "مدينة",
    cityAlt: "مدينة بديلة",
    cityAscii: "مدينة ASCII",
    code: "رمز",
    country: "دولة",
    countryId: "معرف الدولة",
    credit: "ائتمان",
    creditCard: "بطاقة ائتمان",
    creditCardType: "نوع بطاقة ائتمان",
    customer: "عميل",
    customerNo: "رقم العميل",
    customerLedger: "دفتر العميل",
    dashboard: {
      activity: "النشاط",
      weeklySales: "المبيعات الأسبوعية",
      sales: "المبيعات",
      recentOrders: "الطلبات الأخيرة",
      sources: "مصادر الحركة",
      lastweek: "مقارنة بالأسبوع الماضي",
      orders: "الطلبات",
      customers: "العملاء",
      tickets: "تذاكر الدعم",
      viewReport: "عرض التقرير",
      totalPaidOrders: "إجمالي الطلبات المدفوعة",
      totalAmount: "إجمالي المبلغ",
      totalTaxes: "إجمالي الضرائب",
      grandTotal: "الإجمالي الكبير",
      totalQty: "إجمالي الكمية",
      totalGuests: "إجمالي الضيوف",
      totalQuickOrders: "إجمالي الطلبات السريعة",
      foodTotalAmount: "إجمالي مبلغ الطعام",
      foodTotalQty: "إجمالي كمية الطعام",
      beverageTotalAmount: "إجمالي مبلغ المشروبات",
      beverageTotalQty: "إجمالي كمية المشروبات",
      othersTotalAmount: "إجمالي مبلغ أخرى",
      othersTotalQty: "إجمالي كمية أخرى",
      tobaccoTotalAmount: "إجمالي مبلغ التبغ",
      tobaccoTotalQty: "إجمالي كمية التبغ",
      totalCovers: "إجمالي الضيوف (تمت خدمتهم)",
      averageSpendPerGuest: "متوسط الإنفاق لكل ضيف",
      averageTransactionValue: "متوسط قيمة المعاملة",
      assumedTableTurnTime: "الوقت المفترض لتدوير الطاولة",
      averageTableTurnTime: "متوسط وقت تدوير الطاولة",
      seatingCapacity: "سعة الجلوس",
      totalItemsSold: "إجمالي العناصر المباعة",
      totalTransactions: "إجمالي المعاملات",
      summaryMetrics: "مقاييس الملخص",
      potentialCoversPerMealtime: "الضيوف المحتملون لكل وجبة",
      serviceCharge: "رسوم الخدمة ({percent}% من الإيرادات)",
      vatRevenue: "ضريبة القيمة المضافة ({percent}% من الإيرادات)",
      netSales: "صافي المبيعات (بدون ضرائب وخدمة)",
      dateRangeTo: "النطاق الزمني: {s} إلى {e}",
      topThreeItemsSold: "أفضل ثلاثة عناصر مباعة",
      topDiscounts: "أفضل الخصومات",
      outletHours: "ساعات الفرع:",
      breakfast: "الإفطار",
      lunch: "الغداء",
      dinner: "العشاء",
      allDayDining: "تناول الطعام طوال اليوم",
      potentialCoversPerMealTimeDesc: "{potential_cover_per_mealtime} ضيف ({seating_capacity} مقعد x {potential_turns_per_mealtime} تدوير)",
      occupancyRateDesc: "{occupancy_rate} % ({total_covers} ضيف / {total_seats} مقعد x {potential_turns_per_mealtime} تدوير خلال {days_config} أيام)",
      mealTime: "وقت الوجبة",
      allRevenueExcludingComplimentary: "*جميع الإيرادات، باستثناء العناصر المجانية.",
      complimentaryExcluded: "*العناصر المجانية مستبعدة",
      allRevenueAllDayIncludeComplimentary: "*جميع الإيرادات من تناول الطعام طوال اليوم وتشمل الخدمات المجانية.",
    },
    defaultBookingSource: "مصدر الحجز الافتراضي",
    defaultMarketSegment: "القطاع السوقي الافتراضي",
    delete: "حذف",
    deleteConfirmation: "تأكيد الحذف",
    density: "الكثافة",
    description: "الوصف",
    documentNo: "رقم المستند",
    documentType: "نوع المستند",
    edit: "تعديل",
    editCashDesk: "تعديل صندوق نقدي",
    editChannel: "تعديل القناة",
    editCity: "تعديل المدينة",
    editChannelClientCompositionMapping: "تعديل تعيين تكوين عميل القناة",
    editChannelHotelRateCodeMapping: "تعديل تعيين رمز سعر فندق القناة",
    editChannelHotelRoomTypeMapping: "تعديل تعيين نوع غرفة فندق القناة",
    editCountry: "تعديل الدولة",
    editCreditCardType: "تعديل نوع بطاقة ائتمان",
    editGeneralJournal: "تعديل دفتر يومية عام",
    editJournalAccountType: "تعديل نوع حساب دفتر اليومية",
    editJournalBatch: "تعديل دفعة دفتر اليومية",
    editJournalTemplate: "تعديل قالب دفتر اليومية",
    editRoomStatus: "تعديل حالة الغرفة",
    editRoomType: "تعديل نوع الغرفة",
    entryNo: "رقم الإدخال",
    failed: "فشل",
    frontOffice: "المكتب الأمامي",
    generalJournal: "دفتر يومية عام",
    hotelAgency: "وكالة فندقية",
    hotelAgencyGroup: "مجموعة وكالات فندقية",
    hotelClient: "عميل فندقي",
    hotelRate: "سعر الفندق",
    hotelRoomType: "نوع غرفة الفندق",
    iso2Code: "رمز ISO2",
    journalAccountNo: "رقم حساب دفتر اليومية",
    journalAccountType: "نوع حساب دفتر اليومية",
    journalBatch: "دفعة دفتر اليومية",
    journalTemplate: "قالب دفتر اليومية",
    latitude: "خط العرض",
    lineNo: "رقم السطر",
    longitude: "خط الطول",
    mandatory: "إلزامي",
    marketSegment: "القطاع السوقي",
    masterData: "البيانات الرئيسية",
    name: "الاسم",
    new: "جديد",
    no: "لا",
    numericCode: "رمز رقمي",
    officialStateName: "الاسم الرسمي للدولة",
    originalAmount: "المبلغ الأصلي",
    population: "عدد السكان",
    populationProper: "عدد السكان الصحيح",
    postingDate: "تاريخ التسجيل",
    rate: "السعر",
    ranking: "الترتيب",
    roomStatus: "حالة الغرفة",
    roomType: "نوع الغرفة",
    sameName: "نفس الاسم",
    save: "حفظ",
    simpleMapsCityId: "معرف مدينة SimpleMaps",
    successful: "ناجح",
    timezone: "المنطقة الزمنية",
    yes: "نعم",
    email: {
      compose: "إنشاء بريد إلكتروني",
      send: "إرسال",
      subject: "الموضوع",
      labels: "التصنيفات",
      emptyList: "قائمة البريد الإلكتروني فارغة",
      inbox: "الوارد",
      sent: "تم الإرسال",
      drafts: "المسودات",
      starred: "مميز بنجمة",
      trash: "سلة المهملات",
      work: "عمل",
      invoice: "فاتورة",
    },
    todo: {
      addTask: "إضافة مهمة",
      tasks: "المهام",
      completed: "مكتمل",
      labels: "التصنيفات",
    },
    usermenu: {
      profile: "الملف الشخصي",
      signin: "تسجيل الدخول",
      dashboard: "لوحة التحكم",
      signout: "تسجيل الخروج",
    },
    error: {
      notfound: "الصفحة غير موجودة",
      other: "حدث خطأ ما",
    },
    check: {
      title: "تعيين كلمة مرور جديدة",
      backtosign: "العودة لتسجيل الدخول",
      newpassword: "كلمة مرور جديدة",
      button: "تعيين كلمة مرور جديدة وتسجيل الدخول",
      error: "رابط الإجراء غير صالح",
      verifylink: "جارٍ التحقق من الرابط...",
      verifyemail: "جارٍ التحقق من عنوان البريد الإلكتروني...",
      emailverified: "تم التحقق من البريد الإلكتروني! جارٍ إعادة التوجيه...",
    },
    forgot: {
      title: "هل نسيت كلمة المرور؟",
      subtitle: "أدخل بريدك الإلكتروني وسنرسل لك رابطًا لإعادة تعيين كلمة المرور.",
      email: "البريد الإلكتروني",
      button: "طلب إعادة تعيين كلمة المرور",
      backtosign: "العودة لتسجيل الدخول",
    },
    login: {
      title: "تسجيل الدخول",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      button: "تسجيل الدخول",
      orsign: "أو سجل الدخول بواسطة",
      forgot: "هل نسيت كلمة المرور؟",
      noaccount: "ليس لديك حساب؟",
      create: "أنشئ واحدًا هنا",
      error: "البريد الإلكتروني / كلمة المرور غير صحيحة",
    },
    register: {
      title: "إنشاء حساب",
      name: "الاسم الكامل",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      passwordRetype: "أعد كتابة كلمة المرور",
      button: "إنشاء حساب",
      orsign: "أو سجل بواسطة",
      agree: "بالتسجيل، أنت توافق على",
      account: "لديك حساب بالفعل؟",
      signin: "تسجيل الدخول",
    },
    order: {
      cantCorrectPaymentBecauseTaxInterfaceStatusIsValid: "لا يمكن تصحيح الدفع لأن حالة واجهة الضرائب صالحة",
      cantDeletePaymentBecauseTaxInterfaceStatusIsValid: "لا يمكن حذف الدفع لأن حالة واجهة الضرائب صالحة",
    },
    parameter: {
      maxPreviewBillPrintCount: "الحد الأقصى لعدد معاينات طباعة الفاتورة",
      maxPreviewBillPrintCountReached: "تم تجاوز حد الطباعة: لقد وصلت إلى الحد الأقصى المسموح به لمعاينات طباعة الفاتورة.",
      maxPreviewBillPrintCountLimit0: "أدخل '0' لعدم وجود حد",
      numberSeriesAndVATExemption: "الرقم، السلسلة وإعفاء ضريبة القيمة المضافة",
      billPrintSettings: "إعدادات طباعة الفاتورة",
      wrapText: "التفاف النص",
      defaultPrinter: "الطابعة الافتراضية",
      fontSize: "حجم الخط (بالبوينت)",
      topMargin: "الهامش العلوي (بالبوينت)",
      leftMargin: "الهامش الأيسر (بالبوينت)",
      rightMargin: "الهامش الأيمن (بالبوينت)",
      bottomMargin: "الهامش السفلي (بالبوينت)",
      lineOffset: "إزاحة السطر (بالبوينت)",
      hideHotelNameInBillPrint: "إخفاء اسم الفندق في طباعة الفاتورة",
      vatRegNo: "رقم تسجيل ضريبة القيمة المضافة",
      minNo: "الحد الأدنى للرقم",
      snNo: "رقم السلسلة",
      checkNoSeries: "سلسلة أرقام الشيكات",
      receiptNoSeries: "سلسلة أرقام الإيصالات",
      permitNo: "رقم التصريح (STN S/N)",
      accreditedNo: "رقم الاعتماد",
      isEnableExemptVAT: "تمكين إعفاء ضريبة القيمة المضافة",
      allowDeleteSentItems: "السماح بحذف العناصر المرسلة",
      showBraceletAsCollectionType: "عرض السوار كنوع تجميع",
      headerText1: "النص العلوي 1",
      headerText2: "النص العلوي 2",
      footerText1: "النص السفلي 1",
      footerText2: "النص السفلي 2",
      salesCreditMemoSeries: "سلسلة إشعار دائن للمبيعات",
      isSupportExternal: "يدعم الأجهزة الخارجية",
      isCardNumberNotMandatory: "رقم البطاقة غير إلزامي",
      isCardNameNotMandatory: "اسم البطاقة غير إلزامي",
      isCardTraceNoNotMandatory: "رقم التتبع غير إلزامي",
      isDeleteSentOrderReasonNotMandatory: "سبب حذف الطلب المرسل غير إلزامي",
      isCancelOrderReasonNotMandatory: "سبب إلغاء الطلب غير إلزامي",
      isPrintBillOnQuickOrder: "طباعة الفاتورة في الطلب السريع",
      isSendFoodOnQuickOrder: "إرسال نوع منتج الطعام في الطلب السريع",
      isSendBeverageOnQuickOrder: "إرسال نوع منتج المشروبات في الطلب السريع",
      isSendOthersOnQuickOrder: "إرسال نوع منتج آخر في الطلب السريع",
      isSendTobaccoOnQuickOrder: "إرسال نوع منتج التبغ في الطلب السريع",
      showGuestSignatureFieldInPreviewBill: "عرض حقل توقيع الضيف في معاينة الفاتورة",
      showRoomNoFieldInPreviewBill: "عرض حقل رقم الغرفة في معاينة الفاتورة",
      showTipFieldInPreviewBill: "عرض حقل الإكرامية في معاينة الفاتورة",
      font: "الخط",
      textBold: "خط عريض",
      sendOrderPrintSettings: "إعدادات طباعة الطلب المرسل",
      amountOfBillToPrintOnProcessingPayment: "عدد نسخ الفاتورة عند معالجة الدفع",
      isMultiplePaymentGroupedByType: "تجميع المدفوعات المتعددة حسب النوع",
      billPrintShowGuestPaymentAmountOnCash: "عرض مبلغ دفع الضيف عند الدفع نقدًا",
      billPrintLogoWidth: "عرض الشعار (بالبوينت)",
      applyDiscountAndAllowance: "تطبيق الخصومات والبدلات",
      discountArticle: "ربط بهذا العنصر",
      discountAndAllowance: "خصم وبدل",
      applyingDiscountAndAllowancesWill: "تطبيق الخصومات والبدلات سيؤدي إلى",
      activateTheDiscountTotalFeature: "تفعيل ميزة إجمالي الخصم",
      generateDiscountRevenueLinesForBoth: "إنشاء خطوط إيرادات الخصم لكليهما",
      perItemDiscounts: "خصومات لكل عنصر",
      totalDiscounts: "خصومات إجمالية (على مستوى الطلب)",
      theDiscountTotalWillBeMappedToTheSelectedArticle: "سيتم ربط إجمالي الخصم بالعنصر المحدد",
      showGuestNameInSendOrder: "عرض اسم النزيل في إرسال الطلب",
      allowZeroCover: "السماح بتغطية صفرية",
      serialNo: "الرقم التسلسلي",
      stnSn: "STN S/N",
      showManualOrNumber: "عرض الإدخال اليدوي أو الرقم (نقداً وبطاقة)",
      allowPackageMemberDiscount: "السماح بالخصم لعناصر أعضاء الحزمة",
    },
    printerType: {
      printerName: "اسم الطابعة",
      paperWidth: "عرض الورق (مم)",
      paperHeight: "طول الورق (مم)",
    },
    bill: {
      vatRegNo: "رقم تسجيل ضريبة القيمة المضافة",
      minNo: "الحد الأدنى للرقم",
      snNo: "رقم السلسلة",
      check: "شيك",
      receiptNo: "رقم الإيصال",
      guest: "ضيف",
      date: "التاريخ",
      time: "الوقت",
      table: "الطاولة",
      waiter: "النادل",
      preview: "معاينة",
      copy: "نسخة",
      original: "أصلي",
      officialReceipt: "إيصال رسمي",
      receipt: "إيصال",
      amountWithVAT: "المبلغ مع ضريبة القيمة المضافة",
      lessVAT: "أقل ضريبة القيمة المضافة",
      amountWithoutVAT: "المبلغ بدون ضريبة القيمة المضافة",
      subtotal: "المجموع الفرعي",
      permitNo: "رقم التصريح",
      accreditedNo: "رقم الاعتماد",
      billPreparedBy: "تم إعداد الفاتورة بواسطة",
      billPrintedAt: "تم طباعة الفاتورة في",
      payment: "الدفع",
      paid: "مدفوع",
      change: "الباقي",
      name: "الاسم",
      guestName: "اسم الضيف",
      signature: "التوقيع",
      roomNo: "رقم الغرفة",
      accountNo: "رقم الحساب",
      description: "الوصف",
      qty: "الكمية",
      price: "السعر",
      totalAmount: "إجمالي المبلغ",
      amountCharged: "المبلغ المحمل",
      taxDeclaration: "إقرار ضريبي",
      officialReceiptNote1: "يعد هذا إيصالاً رسمياً إذا",
      officialReceiptNote2: "تم الدفع نقدًا وبطاقة ائتمان",
      item: "عنصر",
      total: "الإجمالي",
    },
    price: {
      currentBasePrice: "سعر الأساس الحالي",
      currentPPVATSetupPrice: "سعر إعداد ضريبة القيمة المضافة للفترة الحالية",
      currentAGOVATSetupPrice: "سعر إعداد ضريبة القيمة المضافة لمجموعة العناصر الحالية",
      currentExemptedVATSetupPrice: "سعر إعداد ضريبة القيمة المضافة المعفى الحالي",
      vatPriceSetupCode: "رمز إعداد سعر ضريبة القيمة المضافة",
      vatAGOSetupCode: "رمز إعداد ضريبة القيمة المضافة لمجموعة العناصر",
      vatExemptedSetupCode: "رمز إعداد ضريبة القيمة المضافة المعفى",
      articleArticleGroupId: "معرف مجموعة العناصر",
      showPackageOrderDetailPrice: "إظهار سعر تفاصيل طلب الحزمة",
    },
    generalSetup: {
      printDeletedSentOrder: "طباعة الطلبات المرسلة المحذوفة",
      systemInfo: "معلومات النظام",
      systemName: "اسم النظام",
      systemVatRegTin: "رقم ضريبة القيمة المضافة للنظام (VAT REG TIN)",
      vatRegTin: "رقم ضريبة القيمة المضافة (VAT REG TIN)",
      systemAccrNo: "رقم الاعتماد للنظام",
      accrNo: "رقم الاعتماد",
      dateIssued: "تاريخ الإصدار",
      validUntil: "صالح حتى",
      systemAccrIssuedDate: "تاريخ إصدار اعتماد النظام",
      systemAccrValidUntil: "صلاحية اعتماد النظام حتى",
      systemPtuNo: "رقم PTU للنظام",
      ptuNo: "رقم PTU",
      systemAddress: "عنوان النظام",
      systemPtuIssuedDate: "تاريخ إصدار PTU للنظام",
    },
    faq: {
      call: "هل لديك أسئلة أخرى؟ يرجى التواصل معنا ",
    },
    ecommerce: {
      products: "المنتجات",
      filters: "الفلاتر",
      collections: "المجموعات",
      priceRange: "نطاق السعر",
      customerReviews: "مراجعات العملاء",
      up: "وأعلى",
      brand: "العلامة التجارية",
      search: "ابحث عن منتج",
      results: "النتائج ( {0} من {1} )",
      orders: "الطلبات",
      shipping: "الشحن",
      freeShipping: "شحن مجاني",
      inStock: "متوفر في المخزون",
      quantity: "الكمية",
      addToCart: "أضف إلى السلة",
      buyNow: "اشتر الآن",
      price: "السعر",
      about: "حول هذا العنصر",
      description: "الوصف",
      reviews: "المراجعات",
      details: "تفاصيل المنتج",
      cart: "السلة",
      summary: "ملخص الطلب",
      total: "الإجمالي",
      discount: "خصم",
      subtotal: "المجموع الفرعي",
      continue: "متابعة التسوق",
      checkout: "الدفع",
    },
    menu: {
      rateManagement: "إدارة الأسعار",
      reservation: "الحجز",
      reservationNew: "جديد",
      reservationList: "قائمة",
      frontOffice: "المكتب الأمامي",
      generalSettings: "الإعدادات العامة",
      guestTitle: "لقب الضيف",
      guestDocumentType: "نوع وثيقة الضيف",
      manageHotel: "الفندق",
      hotel: "فندق",
      hotelList: "قائمة",
      hotelCategory: "فئة الفندق",
      hotelChain: "سلسلة الفنادق",
      marketSegment: "القطاع السوقي",
      rooms: "الغرف",
      currency: "العملة",
      search: "بحث (اضغط \"ctrl + /\" للتركيز)",
      dashboard: "لوحة التحكم",
      logout: "تسجيل الخروج",
      profile: "الملف الشخصي",
      blank: "صفحة فارغة",
      pages: "الصفحات",
      others: "أخرى",
      email: "البريد الإلكتروني",
      chat: "الدردشة",
      todo: "المهام",
      board: "لوحة المهام",
      users: "المستخدمون",
      usersList: "قائمة",
      usersEdit: "تعديل",
      ecommerce: "التجارة الإلكترونية",
      ecommerceList: "المنتجات",
      ecommerceProductDetails: "تفاصيل المنتج",
      ecommerceOrders: "الطلبات",
      ecommerceCart: "السلة",
      auth: "صفحات المصادقة",
      authLogin: "تسجيل الدخول / التسجيل",
      authRegister: "التسجيل",
      authVerify: "تأكيد البريد الإلكتروني",
      authForgot: "نسيت كلمة المرور",
      authReset: "إعادة تعيين كلمة المرور",
      errorPages: "صفحات الخطأ",
      errorNotFound: "غير موجود / 404",
      errorUnexpected: "غير متوقع / 500",
      utilityPages: "صفحات الأدوات",
      utilityMaintenance: "تحت الصيانة",
      utilitySoon: "قريباً",
      utilityHelp: "الأسئلة الشائعة / المساعدة",
      levels: "مستويات القائمة",
      disabled: "القائمة معطلة",
      docs: "التوثيق",
      feedback: "ملاحظات",
      support: "الدعم",
      tables: "الجداول",
      orderHistories: "سجلات الطلبات",
      all: "الكل",
      closed: "مغلق",
      open: "مفتوح",
      deletedSentOrders: "الطلبات المرسلة المحذوفة",
      deletedOrderPayments: "مدفوعات الطلبات المحذوفة",
      transferOrderHistory: "سجل تحويل الطلبات",
      closedDays: "أيام الإغلاق",
      screens: "الشاشات",
      masterData: "البيانات الرئيسية",
      outlet: "الفرع",
      generalSetup: "الإعدادات العامة",
      parameter: "المعاملات",
      table: "الجدول",
      articleProductType: "نوع منتج المقالة",
      article: "مقالة",
      articleGroup: "مجموعة المقالات",
      articleGroupSetup: "إعداد مجموعة المقالات",
      articleGroupOutletSetup: "إعداد مجموعة المقالات للفرع",
      articleFlavourGroup: "مجموعة النكهات للمقالة",
      articleFlavour: "نكهة المقالة",
      articleFlavourGroupArticleGroupSetup: "إعداد مجموعة النكهات لمجموعة المقالات",
      collectionCategory: "فئة المجموعة",
      collectionType: "نوع المجموعة",
      collectionIdentificationGroup: "مجموعة تعريف المجموعة",
      collectionIdentification: "تعريف المجموعة",
      collectionTypeOutletSetup: "إعداد نوع المجموعة للفرع",
      price: "السعر",
      discount: "خصم",
      printer: "الطابعة",
      screen: "الشاشة",
      agent: "الوكيل",
      banquet: "الوليمة",
      banquetGroupList: "قائمة مجموعات الولائم",
      banquetReservationList: "قائمة حجوزات الولائم",
      banquetReservationCalendar: "تقويم حجوزات الولائم",
      reports: "التقارير",
      masterAccount: "الحساب الرئيسي",
      incomeAudit: "تدقيق الدخل",
      outletStatus: "حالة الفرع",
      manageNfcBracelet: "إدارة سوار NFC",
      taxInterfaceIntegrationLog: "سجل تكامل واجهة الضرائب",
      workingDay: "يوم العمل",
      index: "الفهرس",
      printerType: "نوع الطابعة",
      fbMenuOrderRequest: "طلب من قائمة المأكولات والمشروبات",
      tableLabelManagement: "إدارة تسميات الطاولات",
      package: "الحزمة",
    },
    localCommon: {
      dashboardWithItem: "لوحة التحكم {item}",
      top10ItemsSoldWithItem: "أفضل 10 عناصر مباعة - {item}",
      roomRevenueBreakdown: "تفصيل إيرادات الغرف",
      inHouseList: "قائمة النزلاء",
      openDay: "فتح اليوم",
      closeDay: "إغلاق اليوم",
      to: "إلى",
    },
    button: {
      add: "إضافة",
    },
    collectionType: {
      oneCollectionTypePerCategoryPerOutlet: "يرجى التأكد من أن كل فرع لديه نوع مجموعة واحد على الأقل لكل فئة مجموعة. بالنسبة لفئة المجموعة BRACELET، يجب أن يكون لكل فرع نوع مجموعة واحد فقط",
    },
    variance: "التباين",
    mealDate: "تاريخ الوجبة",
    cannotModifySelectedData: "لا يمكن تعديل البيانات المحددة",
    startOperatingHour: "ساعة بدء التشغيل",
    endOperatingHour: "ساعة انتهاء التشغيل",
    foodAndBeverage: "الأطعمة والمشروبات",
    allDepartments: "جميع الأقسام",
    selectAllDepartments: "تحديد جميع الأقسام",
    currCollectionType: "نوع المجموعة الحالي",
    changeCollectionType: "تغيير نوع المجموعة",
    addItem: "إضافة {item}",
    quickOrder: "طلب سريع",
    mealTimeSetup: "إعداد وقت الوجبة",
    tableReservation: "حجز طاولة",
    breakfastRegistration: "تسجيل الإفطار",
    mealRegistration: "تسجيل الوجبة",
    roomBreakfastRegistration: "تسجيل الإفطار في الغرفة",
    roomLunchRegistration: "تسجيل الغداء في الغرفة",
    roomDinnerRegistration: "تسجيل العشاء في الغرفة",
    banquetLunchRegistration: "تسجيل غداء الوليمة",
    banquetDinnerRegistration: "تسجيل عشاء الوليمة",
    itemLoan: "إعارة عنصر",
    courseStage: "مرحلة الدورة",
    intercompanyMapping: "تعيين بين الشركات",
    guestProfiles: "ملفات الضيوف",
    availableDownloads: "التنزيلات المتاحة",
    checkVersion: "تحقق من الإصدار",
    pleaseCheckDeviceConfigurationSentecAgent: "يرجى التحقق من إعداد الجهاز والتكوين وخدمة Sentec Agent بشكل صحيح",
    pleaseCheckDeviceAndConfigAndPMSInterfaceServer: "يرجى التحقق من إعداد الجهاز والتكوين بشكل صحيح. إذا كان كل شيء صحيحًا، تأكد من أن خادم PMS Interface يعمل",
    viewDownloads: "عرض التنزيلات",
    cancelConfirmation: "إلغاء التأكيد",
    salesByTableLabelReport: "تقرير المبيعات حسب تصنيف الجدول",
    label: "ملصق",
    betaTesting: "اختبار تجريبي",
    currentItem: "الحالي {item}",
    changeItem: "تغيير {item}",
    edcMachineIntegration: "دمج آلة EDC",
    enableEdcMachine: "تفعيل جهاز EDC",
    edcMode: "وضع EDC",
    edcModeAlways: "استخدم EDC دائمًا",
    edcModePrompt: "اطلب من المحاسب الاختيار",
    edcAgentUrl: "رابط وكيل سنتك",
    edcAgentUrlPlaceholder: "اتركه فارغًا لاستخدام رابط pos.agent",
    edcAgentUrlHint: "يعود إلى عنوان pos.agent إذا لم يتم تعيينه",
    edcAgentToken: "رمز وكيل سنتك",
    edcAgentTokenPlaceholder: "اتركه فارغًا لاستخدام رمز pos.agent",
    edcAgentTokenHint: "يتجاوز رمز الوكيل عند التعيين",
    edcVendor: "بائع EDC",
    edcComPort: "منفذ COM",
    edcComPortPlaceholder: "مثال: COM3",
    edcTestConnection: "اختبر الاتصال",
    edcConnected: "متصل",
    edcFailed: "فشل",
    edcEnterAgentUrlFirst: "يرجى إدخال عنوان URL لوكيل سنتك أولاً.",
    edcPayment: "دفع EDC",
    edcInvoiceAmountRemaining: "المبلغ المتبقي من الفاتورة",
    edcUserPayment: "دفع المستخدم",
    edcTerminalWillReceive: "سيستقبل الطرفية: {amount} ({currency} وحدات فرعية)",
    edcChange: "تغيير",
    edcRemainingPayment: "المبلغ المتبقي",
    edcPressPayToInitiate: "اضغط على دفع لبدء عملية EDC",
    edcWaitingForCard: "انتظار لمسة البطاقة / الإدخال...",
    edcSecondsRemaining: "{ثواني} متبقية",
    edcCancel: "إلغاء",
    edcTransactionApproved: "تمت الموافقة على المعاملة",
    edcTransactionFailed: "فشل المعاملة",
    edcRetry: "إعادة المحاولة",
    edcPayViaEdc: "الدفع عبر EDC",
    edcConfirm: "تأكيد",
    edcCard: "بطاقة",
    edcAuthCode: "رمز التوثيق",
    edcTraceNumber: "تتبع #",
    edcTerminal: "المحطة",
    edcTransactionDeclined: "تم رفض المعاملة",
    edcConnectionFailed: "فشل الاتصال بجهاز EDC",
    edcTotalPaymentAlreadyEqual: "إجمالي الدفع يساوي مبلغ الفاتورة بالفعل.",
    postingGroupFollowsClient: "لا توجد مجموعة نشر للعميل - تتبع مجموعة النشر العميل",
    lockClientPostingGroup: "قفل مجموعة نشر العميل",
  },
  m: {
    dimensionValueNotInDimension: "هذه القيمة تنتمي إلى بعد آخر. اختر قيمة من البعد المحدد.",
    dimensionSetupOwnerChanged: "تغيّر السجل المحدد. لم يتم حفظ البعد — أعد فتح الإعداد وحاول مرة أخرى.",
    saveFirstBeforeDimensionSetup: "احفظ هذا السجل أولاً ثم قم بإعداد أبعاده.",
    fieldIsRequired: "هذا الحقل مطلوب",
    confirmDelete: "هل أنت متأكد أنك تريد حذف {f}؟ لا يمكن التراجع عن هذه العملية.",
    err: {
      betLen: "يجب أن يكون {f} بين {v1} و {v2} حرفًا",
      ge: "يجب أن يكون {f} أكبر من أو يساوي {v}",
      gt: "يجب أن يكون {f} أكبر من {v}",
      le: "يجب أن يكون {f} أقل من أو يساوي {v}",
      lt: "يجب أن يكون {f} أقل من {v}",
      maxLen: "يجب أن يكون {f} بحد أقصى {v} حرفًا",
      maxVal: "القيمة القصوى لـ {f} هي {v}{x}",
      minLen: "يجب أن يكون {f} بحد أدنى {v} حرفًا",
      minMaxVal: "يجب أن تكون قيمة {f} من {v1}{x} إلى {v2}{x}",
      minVal: "القيمة الدنيا لـ {f} هي {v}{x}",
      number: "يجب أن يكون {f} رقمًا، سواء موجب أو سالب",
      numeric: "يجب أن يتكون {f} من أرقام فقط",
      req: "{f} مطلوب",
      cantXWhileOffline: "لا يمكن {x} أثناء عدم الاتصال",
      duplicate: "{f} {v} موجود بالفعل",
    },
    confirmCancel: "هل أنت متأكد أنك تريد إلغاء {f}؟ لا يمكن التراجع عن هذه العملية.",
    confirmLogout: "هل أنت متأكد أنك تريد تسجيل الخروج؟",
    confirmFlushSiteData: "هل أنت متأكد أنك تريد مسح بيانات الموقع؟ سيتم تسجيل خروجك وتحديث الصفحة.",
    successFlushSiteData: "تم مسح بيانات الموقع. سيتم تسجيل خروجك وسيتم تحديث الصفحة الآن.",
    invalidPhoneNumber: "رقم الهاتف غير صالح، يُسمح فقط بالأرقام و +",
    invalidDateOfBirth: "تاريخ الميلاد غير صالح. يرجى استخدام التنسيق YYYY-MM-DD.",
  },
  common: {
    add: "إضافة",
    cancel: "إلغاء",
    description: "الوصف",
    delete: "حذف",
    title: "العنوان",
    save: "حفظ",
    faq: "الأسئلة الشائعة",
    contact: "اتصل بنا",
    tos: "شروط الخدمة",
    policy: "سياسة الخصوصية",
    articleFlavour: "نكهة المقال",
    showFlavour: "عرض النكهة",
    hide: "إخفاء",
    articleGroupName: "مجموعة المقالات",
    created: "تم الإنشاء",
    updated: "محدث",
    deleted: "تم الحذف",
  },
  agent: {
    sentecAgentConfigSettings: "إعدادات تكوين وكيل Sentec",
    sentecAgentAccounts: "حسابات وكيل Sentec (V2)",
    sentecAgentAccountsDesc: "حسابات وكيل Sentec لاستخدام بروتوكول اتصال WebSocket",
    availableDownloads: "التنزيلات المتاحة",
    checkVersion: "تحقق من الإصدار",
    pleaseCheckDeviceConfigurationSentecAgent: "يرجى التحقق من إعداد الجهاز والتكوين وخدمة Sentec Agent بشكل صحيح",
    pleaseCheckDeviceAndConfigAndPMSInterfaceServer: "يرجى التحقق من إعداد الجهاز والتكوين بشكل صحيح. إذا كان كل شيء صحيحًا، تأكد من أن خادم PMS Interface يعمل",
    viewDownloads: "عرض التنزيلات",
  },
  board: {
    titlePlaceholder: "أدخل عنوانًا لهذه البطاقة",
    deleteDescription: "هل أنت متأكد أنك تريد حذف هذه البطاقة؟",
    editCard: "تعديل البطاقة",
    deleteCard: "حذف البطاقة",
    state: {
      TODO: "للقيام به",
      INPROGRESS: "قيد التنفيذ",
      TESTING: "اختبار",
      DONE: "تم",
    },
  },
  chat: {
    online: "المستخدمون المتصلون ({count})",
    addChannel: "إضافة قناة",
    channel: "قناة | قنوات",
    message: "رسالة",
  },
  utility: {
    maintenance: "تحت الصيانة",
  },
  order: {
    redirectReceiptVerificationURL: "إعادة توجيه رابط التحقق من الإيصال",
    cantCorrectPaymentBecauseTaxInterfaceStatusIsValid: "لا يمكن تصحيح الدفع لأن حالة واجهة الضريبة صالحة",
    cantDeletePaymentBecauseTaxInterfaceStatusIsValid: "لا يمكن حذف الدفع لأن حالة واجهة الضريبة صالحة",
    deleteSentOrder: "حذف الطلب المرسل",
    closeOrder: "إغلاق الطلب",
    closeOrderConfirmation: "هل أنت متأكد أنك تريد إغلاق هذا الطلب؟",
    pastDateClientCompositionWarning: "هذا الطلب من تاريخ عمل مغلق. سيتم أيضًا نقل فاتورة المبيعات وقيود الدفع في المالية إلى العميل الجديد.",
  },
  outlet: {
    discountGuestActuallyReceives: "ما يحصل عليه الضيف فعليًا",
    discountUnaffectedPercentage: "خصم بنسبة مئوية — لا يتغير",
    discountUnaffectedRateUnchanged: "معدل الضريبة على هذا البند لا يتغير",
    discountImpactTotal: "الإجمالي",
    discountExemptionImpactIntro: "تحتوي بعض العناصر المحددة على خصم بمبلغ. تغيير إعفاء ضريبة القيمة المضافة يغيّر الضريبة على تلك البنود، لذا اختر القيمة التي تريد الحفاظ عليها.",
    discountKeepBaseColumn: "خصم الضيف — إذا حافظت على الأساس",
    discountKeepGuestColumn: "الخصم الأساسي — إذا حافظت على خصم الضيف",
    discountKeepBaseOption: "الحفاظ على المبالغ الأساسية — يتغير الخصم الذي يحصل عليه الضيف",
    discountKeepGuestOption: "الحفاظ على خصم الضيف — يُعاد حساب المبالغ الأساسية",
    discountClampedToBase: "محدود بالمبلغ الأساسي للعنصر",
    discountClampWarning: "في البنود المحدودة لا يمكن الحفاظ على خصم الضيف بالكامل: لا يجوز أن يتجاوز الخصم المبلغ الأساسي للعنصر.",
    discountImpactApply: "تطبيق",
    taxDeclaration: "إقرار ضريبي",
    vatExemptionNote: "ملاحظة إعفاء ضريبة القيمة المضافة",
    applyDiscountWithVATExemptionToOutletWithDisabledExemptVAT: "لا يمكن تطبيق الخصم مع إعفاء ضريبة القيمة المضافة لأن إعداد 'تمكين إعفاء ضريبة القيمة المضافة' غير مفعل.",
    exemptUnexemptVAT: "إعفاء / إلغاء إعفاء ضريبة القيمة المضافة",
    exemptVAT: "إعفاء ضريبة القيمة المضافة",
    unExemptVAT: "إلغاء إعفاء ضريبة القيمة المضافة",
    noPriceSetup: "لا يوجد إعداد سعر",
    noPriceAssignedToThisArticleOnCurrentWorkingDateContinue: "لا يوجد سعر مخصص لهذا المنتج في تاريخ العمل الحالي. هل تريد المتابعة؟",
    cantAddArticleBecauseNoPriceAssignedToThisArticleOnCurrentWorkingDateAndAllowManualPriceIsSetToFalse: "لا يمكن إضافة المنتج لأنه لا يوجد سعر مخصص لهذا المنتج في تاريخ العمل الحالي وخيار السماح بالسعر اليدوي غير مفعل.",
    cantSelectSavedOrSentItemIfInGarnishMode: "لا يمكنك اختيار عنصر تم إرساله أو حفظه بالفعل إذا كانت وضع الزينة مفعلًا",
    cantSetCourseStageOfChildWhileParentNotSelected: "لا يمكن تعيين مرحلة الدورة للعنصر الفرعي دون تحديد العنصر الرئيسي",
    processingOrder: "جاري معالجة الطلب",
    creatingQuickOrder: "إنشاء طلب سريع",
    creatingOrder: "إنشاء الطلب",
    createOrder: "إنشاء طلب",
    createOrderForX: "إنشاء طلب لحجز طاولة باسم الضيف {x}",
    itemAlreadySaved: "تم حفظ العنصر بالفعل",
    itemAlreadySent: "تم إرسال العنصر بالفعل",
    noItemToPay: "لا يوجد عنصر للدفع",
    failedToPrintTo: "فشل الطباعة إلى {x}",
    successToPrintTo: "تم الطباعة إلى {x}",
    captainOrderIminNotThisDevice: "‏{x} طابعة مدمجة في جهاز آخر، لذا تعذّرت طباعة طلب الكابتن عليها.",
    captainOrderM7NeedsAgent: "‏{x} خادم طباعة على الجهاز بدون وكيل معيّن. عيّن وكيلاً له حتى تصل إليه طلبات الكابتن.",
    captainOrderIminNotConnected: "تعذّر الاتصال بالطابعة المدمجة في هذا الجهاز ({x}).",
    captainOrderIminStatusError: "أبلغت الطابعة المدمجة في هذا الجهاز ({x}) عن الحالة {status}، لذا لم تتم طباعة طلب الكابتن.",
    retry: "إعادة المحاولة",
    invalidPaymentMethod: "طريقة الدفع غير صالحة",
    customerOrderX: "طلب العميل {x}",
    pleaseSelectItemsToSend: "يرجى اختيار العنصر(العناصر) للإرسال",
    itemsRemovedFromTheList: "تمت إزالة العنصر(ات) من القائمة",
    missingInvoiceSeries: "سلسلة الفواتير مفقودة",
    cantChooseXForSplitPayment: "لا يمكن اختيار {x} للدفع بالتقسيط",
    amountToPay: "المبلغ المستحق",
    amountToPayCantBeGreaterThanRemainingPayment: "المبلغ المدفوع لا يمكن أن يكون أكبر من المبلغ المتبقي",
    amountToPayCantBeGreaterThanSplitRemainder: "المبلغ المدفوع لا يمكن أن يكون أكبر من المبلغ المتبقي على هذا التقسيم",
    selectSplitPaymentFirst: "اختر التقسيم قبل إضافة دفعة",
    fireX: "أطلق {x}",
    hold: "امسك",
    setStage: "تعيين المرحلة",
    selectOutlet: "اختر المتجر",
    xPax: "{x} شخص",
    orderIDIsNotGenerated: "لم يتم إنشاء رقم الطلب بعد",
    cantDeleteChildOfSentItem: "لا يمكن حذف عنصر فرعي من العناصر المرسلة دون حذف العنصر الرئيسي",
    cantDeleteSentOrderWhileOffline: "لا يمكن حذف الطلب المرسل أثناء عدم الاتصال بالإنترنت",
    cancelOrderDocBillPrinterNotConfigured: "لم تتم طباعة مستند إلغاء الطلب: لم يتم تكوين طابعة فاتورة افتراضية لهذا المنفذ.",
    labelPrinterNotConfigured: "لم يتم تكوين طابعة الملصقات لهذه النقطة. قم بتعيين طابعة ملصقات في إعدادات معامل نقطة البيع.",
    orderType: "نوع الطلب",
    dineIn: "تناول داخل المطعم",
    pickup: "استلام",
    labelPrinter: "طابعة الملصقات",
    alsoPrintStickyLabel: "طباعة الملصقات اللاصقة أيضًا",
    labelPrinterId: "معرّف طابعة الملصقات",
    printLabel: "طباعة الملصق",
    noItemSelectedToPrintLabel: "لم يتم تحديد أي عناصر لطباعة الملصقات.",
    labelOnlyForSentItems: "لا يمكن طباعة الملصقات إلا للعناصر المُرسلة.",
    cantPrintLabelClosedOrder: "لا يمكن طباعة الملصقات لطلب مغلق أو ملغى.",
    cancelOrderDocOutletMissing: "لا يمكن الطباعة: العناصر المحددة تفتقد معلومات المنفذ.",
    cancelOrderDocSingleOutletOnly: "لا يمكن الطباعة عبر منافذ متعددة — يرجى تحديد عناصر من منفذ واحد.",
    cancelOrderDocParameterNotFound: "لا يمكن الطباعة: لم يتم العثور على معاملة POS للمنفذ.",
    cancelOrderDocNotEnabledForOutlet: "طباعة مستند إلغاء الطلب غير مفعلة لهذا المنفذ.",
    cantChangeQtySentItem: "لا يمكن تغيير الكمية لأن عنصرًا واحدًا على الأقل من العناصر المختارة تم إرساله بالفعل.",
    flavourCantAssignToChild: "لا يمكن تعيين النكهة لعنصر فرعي.",
    flavourItemAlreadySent: "تم إرسال العنصر بالفعل.",
    flavourNothingSelected: "لم يتم اختيار أي عنصر لتعيين النكهة له.",
    flavourOnlySingleParent: "يمكن تعيين النكهة لمقالة رئيسية واحدة فقط.",
    qtyChangeNoSelection: "لم يتم اختيار أي مقالة أو زينة لتطبيق تغيير الكمية.",
    qtyChangeMultipleSelection: "هناك أكثر من مقالة و/أو زينة واحدة محددة لتطبيق تغيير الكمية.",
    cantSendZeroPriceItems: "لا يمكن إرسال العناصر التي يكون مجموع سعرها 0 أو أقل.",
    itemsAlreadySent: "تم إرسال عنصر واحد أو أكثر من العناصر المحددة بالفعل.",
    noPrinterOrScreenConfigured: "لا توجد طابعة أو شاشة مهيأة لإرسال هذا الطلب.",
    parentNotSelectedForSend: "لا يمكن إرسال عنصر فرعي بينما لم يتم تحديد العنصر الرئيسي.",
    cantSendOrderWhileOffline: "لا يمكن إرسال الطلب عند عدم الاتصال بالإنترنت.",
    packageMemberDiscountDisabled: "لا يمكن تطبيق الخصم على عناصر أعضاء الحزمة لأن هذا الخيار معطل في إعدادات معاملات نقاط البيع.",
    garnishNotApplicableForPackage: "الإضافات غير قابلة للتطبيق على عناصر الحزمة.",
    ignoredSetStageForPackage: "المرحلة غير قابلة للتطبيق على عناصر الحزمة.",
    changePriceNotAllowedForPackage: "تغيير السعر غير مسموح لعناصر الحزمة.",
    cantModifySelectedTotalDiscount: "لا يمكن تعديل الخصم الكلي المحدد.",
    discountTotal: "إجمالي الخصم",
    noItem: "لا يوجد عنصر",
    allSavedItemsAlreadyHaveDiscountApplied: "جميع العناصر المحفوظة تم تطبيق الخصم عليها بالفعل.",
    cantHaveMultipleDiscountTotal: "لا يمكن وجود إجمالي خصومات متعددة.",
    maxDiscountToApply: "أقصى خصم للتطبيق",
    cashReceived: "تم استلام النقد",
    cashChange: "تغيير",
    outletType: "نوع المنفذ",
    roomService: "خدمة الغرف",
    noItemSelectedToAssignVAT: "لم يتم تحديد عنصر لتعيين إعفاء / عدم إعفاء ضريبة القيمة المضافة",
    exemptVATCantBeAppliedToFlavour: "لا يمكن تطبيق إعفاء / عدم إعفاء ضريبة القيمة المضافة على النكهة",
    unexemptVATForSelectedItem: "سيؤدي هذا إلى عدم إعفاء ضريبة القيمة المضافة للعنصر المحدد. هل أنت متأكد؟",
    unexemptVATForXItems: "سيؤدي هذا إلى عدم إعفاء ضريبة القيمة المضافة لـ {x} عنصر محدد. هل أنت متأكد؟",
    mixedVATSelection: "لقد اخترت {x} عنصر(عناصر) بدون إعفاء ضريبة القيمة المضافة و {y} عنصر(عناصر) معفاة بالفعل. اختر كيف تريد المتابعة.",
    discountAppliesToNonExemptOnly: "سيتم تطبيق الخصم على {x} عنصر(عناصر) بدون إعفاء ضريبة القيمة المضافة فقط — ولن يتم تغيير {y} عنصر(عناصر) معفاة بالفعل.",
    discountSkippedLines: "لن يتم تطبيق الخصم على هذه العناصر وستبقى دون تغيير، لأن الخصم اليدوي غير مسموح لها: {items}",
    discountExemptProofsDiffer: "العناصر المحددة تحمل إثباتات مختلفة لإعفاء ضريبة القيمة المضافة (رقم PWD أو رقم كبير السن أو ملاحظة مختلفة). خصمها معًا سيطبّق إثبات عنصر واحد على الجميع، لذا طبّق الخصم عنصرًا واحدًا في كل مرة.",
    quantityLimitExceeded: "{name}: تم تجاوز الحد الأقصى للكمية المباعة يومياً ({limit}). المتبقي {remaining}، يرجى مراجعة الكمية.",
    failedToSendToPrinterOrScreen: "فشل إرسال الطلب إلى الطابعة أو شاشة المطبخ. سيتم حفظ الطلب.",
  },
  discount: {
    amountIsBaseTaxAdded: "المبلغ المُدخل هو مبلغ أساسي. تُضاف الضرائب ورسوم الخدمة عند الاقتضاء، لذا قد يكون المبلغ المخصوم من الإجمالي أكبر من المبلغ المُدخل.",
    taxAndServiceChargeIncluded: "شامل الضرائب ورسوم الخدمة",
    taxIncludedMasterHint: "الافتراضي عندما يكون نوع القيمة مبلغًا",
    isExemptVAT: "إعفاء ضريبة القيمة المضافة",
    exemptionProofType: "إثبات إعفاء ضريبة القيمة المضافة",
    useExemptionNote: "استخدم الملاحظة",
    usePwdId: "استخدم هوية ذوي الاحتياجات الخاصة",
    useSeniorCitizenId: "استخدم هوية كبار السن",
    pwdId: "هوية ذوي الاحتياجات الخاصة",
    seniorCitizenId: "هوية كبار السن",
    pwdName: "اسم ذوي الاحتياجات الخاصة",
    seniorCitizenName: "اسم كبار السن",
  },
  localColumns: {
    dimensionCode: "رمز البعد",
    dimensionName: "اسم البعد",
    dimensionValueCode: "رمز قيمة البعد",
    dimensionValueName: "اسم قيمة البعد",
    expenseDimensions: "أبعاد المصروف",
    costDimensions: "أبعاد التكلفة",
    topProduct: "أفضل منتج",
    hour: "ساعة",
    salesRevenue: "إيرادات المبيعات",
    transactions: "المعاملات",
    averageTransactions: "متوسط المعاملات",
    averageSales: "متوسط المبيعات",
    quantitySold: "الكمية المباعة",
    averagePrice: "متوسط السعر",
    totalOrders: "إجمالي الطلبات",
    totalSales: "إجمالي المبيعات",
    averageOrderAmount: "متوسط مبلغ الطلب",
    topProductName: "اسم أفضل منتج",
    topProductRevenue: "إيرادات أفضل منتج",
    averageBillSize: "متوسط حجم الفاتورة",
    topBeverageArticle: "أفضل مشروب",
    topFoodArticle: "أفضل طعام",
    currentStock: "المخزون الحالي",
    costPerUnit: "تكلفة لكل وحدة",
    last30DaysSalesQuantity: "كمية المبيعات في آخر 30 يوم",
    daysUntilOutOfStock: "أيام حتى نفاد المخزون",
    averageDaysPerOrder: "متوسط الأيام لكل طلب",
    revenuePercentage: "نسبة الإيرادات",
    discountDescription: "وصف الخصم",
    discountCount: "عدد الخصومات",
    totalDiscountAmount: "إجمالي مبلغ الخصم",
    // PMS-322: the Discount Report's guest-facing (gross) discount. Never "VAT" (R11): the
    // figure includes service charge, and on an exempt line contains no VAT at all.
    discountAmountWithTax: "مبلغ الخصم (شامل الضرائب ورسوم الخدمة)",
    reOrderLevel: "مستوى إعادة الطلب",
    totalRevenueExcludingTax: "إجمالي الإيرادات بدون ضريبة",
    articleGroupName: "اسم مجموعة المقالات",
    creditBalanceAmount: "رصيد الائتمان",
    totalUsedBalance: "الرصيد المستخدم الكلي",
    currentBalance: "الرصيد الحالي",
    allowOverLimit: "السماح بتجاوز الحد",
    foodRevenue: "إيرادات الطعام",
    beverageRevenue: "إيرادات المشروبات",
    costAccount: "حساب التكلفة",
  },
  guestProfile: {
    guestProfile: "ملف الضيف",
    successCreate: "تم إنشاء ملف الضيف بنجاح!",
    successUpdate: "تم تحديث ملف الضيف بنجاح!",
    membership: "العضوية",
    membershipNumber: "رقم العضوية",
    cityNotes: "أدخل 3 أحرف على الأقل للبحث عن مدينة.",
    membershipType: "نوع العضوية",
    customerPIN: "رمز PIN للعميل",
    copyGuestFromFO: "نسخ ملف الضيف من FO؟",
    successCopy: "تم نسخ ملف الضيف بنجاح",
    copyGuestProfile: "نسخ ملف الضيف",
    editGuestProfile: "تعديل ملف الضيف",
    seeFOGuestList: "عرض قائمة ضيوف مكتب الاستقبال",
    foGuestList: "قائمة ضيوف مكتب الاستقبال",
    saveGuestName: "حفظ اسم ملف الضيف",
    posGuestProfile: "ملف ضيف نقطة البيع",
    saveGuestProfileNameConfirmation: "سيتم تحديث اسم ملف الضيف المحدد، هل أنت متأكد؟",
    tinNumber: "رقم التعريف الضريبي",
    scIdNumber: "هوية المواطن المسن",
    pwdIdNumber: "هوية ذوي الاحتياجات الخاصة",
    signatureName: "اسم التوقيع",
    isMembership: "عضوية",
  },
  payment: {
    paymentTab: "الدفع",
    tipTab: "إكرامية",
    tips: "الإكراميات",
    tipType: "النوع",
    tipDescription: "الوصف",
    tipAmount: "مبلغ الإكرامية",
    totalTip: "إجمالي الإكرامية",
    noTips: "-- لا توجد إكراميات --",
    addTip: "إضافة إكرامية",
    tipAmountMustBePositive: "يجب أن يكون مبلغ الإكرامية أكبر من صفر",
    cardNumber: "رقم البطاقة",
    cardName: "اسم حامل البطاقة",
    cardExpirationDate: "تاريخ انتهاء صلاحية البطاقة",
    cardTraceNumber: "رقم تتبع المعاملة",
    cardExpired: "البطاقة منتهية الصلاحية",
    invoiceAmountRemaining: "المبلغ المتبقي في الفاتورة",
    userPayment: "دفع المستخدم",
    amountToPay: "المبلغ المستحق",
    change: "الباقي",
    remainingPayment: "الدفع المتبقي",
    titleHere: "العنوان هنا",
    amountToPayGreaterThanUserPayment: "لا يمكن أن يكون المبلغ المستحق أكبر من دفع المستخدم",
    amountToPayGreaterThanRemainingPayment: "لا يمكن أن يكون المبلغ المستحق أكبر من الدفع المتبقي",
    cantCombinePayment: "لا يمكنك دمج {payment} مع طريقة دفع أخرى",
    totalPaymentEqualInvoiceAmount: "إجمالي الدفعات يساوي بالفعل مبلغ الفاتورة. احذف الدفعات لاختيار طريقة أخرى.",
    paymentIsNotReady: "ميزة الدفع غير جاهزة بعد!",
    notAllowedToLedger: "{payment} غير مسموح به في السجلات",
    disabled: "{payment} معطّل",
    ledger: "دفتر الأستاذ",
    insufficientCredit: "رصيد غير كافٍ للدفع",
    differentClientPostingGroup: "مجموعة نشر عميل مختلفة مع العميل",
    ledgerForm: "نموذج السجل",
    manualOrNumber: "الإدخال اليدوي أو الرقم",
    manualOrNumberRequired: "الإدخال اليدوي أو الرقم مطلوب لمدفوعات النقد أو البطاقة.",
    failedToSaveManualOrNumber: "فشل حفظ الإدخال اليدوي أو الرقم. يرجى المحاولة مرة أخرى.",
    failedToPay: "فشل في معالجة الدفع. تم حفظ الطلب لكن لم يتم دفع الفاتورة. يرجى المحاولة مرة أخرى.",
    availableBalance: "الرصيد المتاح",
    collectionLimitExceededMessage: "تجاوزت هذه الدفعة الحد الائتماني الشهري المتاح لمعرف المجموعة المحدد. يرجى استخدام معرف مجموعة آخر برصيد متاح، أو اطلب من المسؤول تعديل مبلغ الرصيد الائتماني.",
    collectionLimitExceededTitle: "تجاوز حد تعريف المجموعة",
    creditLimit: "حد الائتمان",
    invoiceAmount: "مبلغ الفاتورة",
    overLimitAmount: "مبلغ تجاوز الحد",
    overLimitProcessedMessage: "تمت معالجة المعاملة بمبلغ تجاوز الحد {amount}",
    overLimitWarningMessage: "سيتجاوز هذا الدفع الحد الائتماني الشهري المتاح لمعرف المجموعة المحدد.",
    overLimitWarningTitle: "تحذير تجاوز الحد",
    usedThisMonth: "استخدم هذا الشهر",
  },
  email: {
    compose: "إنشاء بريد إلكتروني",
    send: "إرسال",
    subject: "الموضوع",
    labels: "التسميات",
    emptyList: "قائمة البريد الإلكتروني فارغة",
    inbox: "صندوق الوارد",
    sent: "تم الإرسال",
    drafts: "المسودات",
    starred: "مميز",
    trash: "سلة المهملات",
    work: "عمل",
    invoice: "فاتورة",
    notValid: "البريد الإلكتروني غير صالح",
  },
  todo: {
    addTask: "إضافة مهمة",
    tasks: "المهام",
    completed: "مكتمل",
    labels: "التسميات",
  },
  dashboard: {
    activity: "نشاط",
    weeklySales: "المبيعات الأسبوعية",
    sales: "المبيعات",
    recentOrders: "الطلبات الأخيرة",
    sources: "مصادر الحركة",
    lastweek: "مقارنة بالأسبوع الماضي",
    orders: "طلبات",
    customers: "العملاء",
    tickets: "تذاكر الدعم",
    viewReport: "عرض التقرير",
    totalPaidOrders: "إجمالي الطلبات المدفوعة",
    totalAmount: "المبلغ الإجمالي",
    totalTaxes: "إجمالي الضرائب",
    grandTotal: "المجموع الكلي",
    totalQty: "إجمالي الكمية",
    totalGuests: "إجمالي الضيوف",
    totalQuickOrders: "إجمالي الطلبات السريعة",
    foodTotalAmount: "إجمالي الطعام",
    foodTotalQty: "إجمالي كمية الطعام",
    beverageTotalAmount: "إجمالي المشروبات",
    beverageTotalQty: "إجمالي كمية المشروبات",
    othersTotalAmount: "إجمالي المبلغ للآخرين",
    othersTotalQty: "إجمالي الكمية الأخرى",
    tobaccoTotalAmount: "إجمالي كمية التبغ",
    tobaccoTotalQty: "إجمالي كمية التبغ",
    totalCovers: "إجمالي الضيوف",
    averageSpendPerGuest: "متوسط الإنفاق لكل ضيف",
    averageTransactionValue: "قيمة المعاملة المتوسطة",
    assumedTableTurnTime: "وقت تحويل الطاولة المفترض",
    averageTableTurnTime: "متوسط وقت تحويل الطاولة",
    seatingCapacity: "سعة المقاعد",
    totalItemsSold: "إجمالي العناصر المباعة",
    totalTransactions: "إجمالي المعاملات",
    summaryMetrics: "مقاييس الملخص",
    potentialCoversPerMealtime: "التغطيات المحتملة لكل وجبة",
    serviceCharge: "رسوم الخدمة ({percent}% من الإيرادات)",
    vatRevenue: "ضريبة القيمة المضافة ({percent}% من الإيرادات)",
    netSales: "صافي المبيعات (بدون ضريبة وخدمة)",
    dateRangeTo: "نطاق التاريخ: {s} إلى {e}",
    topThreeItemsSold: "أفضل ثلاثة عناصر مباعة",
    topDiscounts: "أفضل الخصومات",
    outletHours: "ساعات العمل:",
    breakfast: "إفطار",
    lunch: "غداء",
    dinner: "عشاء",
    allDayDining: "تناول الطعام طوال اليوم",
    potentialCoversPerMealTimeDesc: "{potential_cover_per_mealtime} تغطيات ({seating_capacity} مقاعد × {potential_turns_per_mealtime} دورات)",
    occupancyRateDesc: "{نسبة_الإشغال} % ({إجمالي_الضيوف} ضيف / {إجمالي_المقاعد} مقعد × {عدد_الدورات_المحتملة_لكل_وجبة} دورات محتملة على مدى {عدد_الأيام})",
    mealTime: "وقت الوجبة",
    allRevenueExcludingComplimentary: "جميع الإيرادات، باستثناء العناصر المجانية.",
    complimentaryExcluded: "مستبعد مجانًا",
    allRevenueAllDayIncludeComplimentary: "جميع الإيرادات من تناول الطعام طوال اليوم وتشمل خدمات مجانية.",
    totalItemIncludingComplimentaryItems: "إجمالي العناصر بما في ذلك العناصر المجانية",
    totalTransactionsIncludingComplimentary: "إجمالي المعاملات بما في ذلك المجانية",
    totalBaseAmountExcludingComplimentaryItems: "المبلغ الإجمالي الأساسي بدون العناصر المجانية",
    totalCoversNumberOfGuestIncludingComplimentary: "إجمالي التغطيات (عدد الضيوف) بما في ذلك المجاني",
    averageSpendPerGuestExcludingComplimentaryItemsOrServices: "متوسط الإنفاق لكل ضيف، باستثناء العناصر أو الخدمات المجانية.",
    averageTransactionValueExcludingComplimentaryItemsOrServices: "متوسط قيمة المعاملة، باستثناء العناصر أو الخدمات المجانية.",
    averageTableTurnoverTimeComplimentaryExcluded: "متوسط وقت دوران الطاولة، بدون احتساب المجاني",
    percentageOfAvailableSeatCapacityUsedByGuests: "نسبة سعة المقاعد المتاحة التي استخدمها الضيوف",
    totalOrdersIncludeComplimentary: "إجمالي الطلبات يشمل المجاني.",
    totalPaidOrdersIncludeComplimentary: "إجمالي الطلبات المدفوعة تشمل المجانية.",
    clickForDetailsBreakdown: "انقر للتفاصيل",
    totalNumberOfSeatsAvailableForGuests: "إجمالي عدد المقاعد المتاحة للضيوف",
    percentageOfAvailableSeatCapacityActuallyUsedByGuests: "نسبة سعة المقاعد المتاحة التي استخدمها الضيوف فعليًا",
    totalServiceChargeExcludingComplimentaryItems: "إجمالي رسوم الخدمة، باستثناء العناصر المجانية",
    totalVatRevenueExcludingComplimentaryItems: "إجمالي إيرادات ضريبة القيمة المضافة، باستثناء العناصر المجانية",
    totalNetSalesExcludingComplimentaryItems: "إجمالي المبيعات الصافية، باستثناء العناصر المجانية",
    totalTaxesExcludingComplimentaryItems: "إجمالي الضرائب، باستثناء العناصر المجانية",
    totalNetSalesIncludingComplimentaryItems: "إجمالي المبيعات الصافية، بما في ذلك العناصر المجانية",
    totalAmountExcludingComplimentaryItems: "المبلغ الإجمالي، باستثناء العناصر المجانية",
    applyFilter: "تطبيق الفلتر",
  },
  usermenu: {
    profile: "الملف الشخصي",
    signin: "تسجيل الدخول",
    dashboard: "لوحة التحكم",
    signout: "تسجيل الخروج",
  },
  error: {
    notfound: "الصفحة غير موجودة",
    other: "حدث خطأ",
    failedUpdateOrder: "فشل تحديث الطلب",
    noPermission: "ليس لديك إذن لتنفيذ هذا الإجراء",
  },
  check: {
    title: "تعيين كلمة مرور جديدة",
    backtosign: "العودة لتسجيل الدخول",
    newpassword: "كلمة مرور جديدة",
    button: "تعيين كلمة مرور جديدة وتسجيل الدخول",
    error: "رابط الإجراء غير صالح",
    verifylink: "جارٍ التحقق من الرابط...",
    verifyemail: "جارٍ التحقق من عنوان البريد الإلكتروني...",
    emailverified: "تم التحقق من البريد الإلكتروني! جارٍ إعادة التوجيه...",
  },
  forgot: {
    title: "نسيت كلمة المرور؟",
    subtitle: "أدخل بريدك الإلكتروني وسنرسل لك رابطًا لإعادة تعيين كلمة المرور.",
    email: "البريد الإلكتروني",
    button: "طلب إعادة تعيين كلمة المرور",
    backtosign: "العودة إلى تسجيل الدخول",
  },
  login: {
    title: "تسجيل الدخول",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    button: "تسجيل الدخول",
    orsign: "أو تسجيل الدخول باستخدام",
    forgot: "نسيت كلمة المرور؟",
    noaccount: "ليس لديك حساب؟",
    create: "أنشئ واحداً هنا",
    error: "تركيبة البريد الإلكتروني / كلمة المرور غير صالحة",
  },
  register: {
    title: "إنشاء حساب",
    name: "الاسم الكامل",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    passwordRetype: "إعادة كتابة كلمة المرور",
    button: "إنشاء حساب",
    orsign: "أو التسجيل باستخدام",
    agree: "بالتسجيل، أنت توافق على",
    account: "هل لديك حساب بالفعل؟",
    signin: "تسجيل الدخول",
  },
  parameter: {
    stickyLabelPrintSettings: "إعدادات طباعة الملصقات اللاصقة",
    maxPreviewBillPrintCount: "الحد الأقصى لعدد طباعة الفاتورة المعاينة",
    maxPreviewBillPrintCountReached: "تم تجاوز حد الطباعة: لقد وصلت إلى الحد الأقصى المسموح به لطباعة الفاتورة.",
    maxPreviewBillPrintCountLimit0: "أدخل '0' لعدم وجود حد",
    numberSeriesAndVATExemption: "الرقم، السلسلة وإعفاء ضريبة القيمة المضافة",
    billPrintSettings: "إعدادات طباعة الفاتورة",
    wrapText: "لف النص",
    defaultPrinter: "الطابعة الافتراضية",
    fontSize: "حجم الخط (بالنقاط)",
    topMargin: "هامش علوي (بالبوينت)",
    leftMargin: "الهامش الأيسر (بالبوينت)",
    rightMargin: "هامش اليمين (بالبوينت)",
    bottomMargin: "الهامش السفلي (بالنقاط)",
    lineOffset: "إزاحة الخط (بالنقاط)",
    hideHotelNameInBillPrint: "إخفاء اسم الفندق في طباعة الفاتورة",
    vatRegNo: "رقم تسجيل الضريبة المضافة",
    minNo: "الحد الأدنى",
    snNo: "رقم السند",
    checkNoSeries: "رقم شيك غير متسلسل",
    receiptNoSeries: "رقم سلسلة الإيصال",
    permitNo: "رقم التصريح",
    accreditedNo: "رقم معتمد",
    isEnableExemptVAT: "تمكين ضريبة القيمة المضافة المعفاة",
    allowDeleteSentItems: "السماح بحذف العناصر المرسلة",
    showBraceletAsCollectionType: "عرض السوار كنوع مجموعة",
    headerText1: "نص الرأس 1",
    headerText2: "نص العنوان 2",
    footerText1: "نص التذييل 1",
    footerText2: "نص التذييل 2",
    salesCreditMemoSeries: "سلسلة مذكرات ائتمان المبيعات",
    isCardNumberNotMandatory: "رقم البطاقة غير إلزامي",
    isCardNameNotMandatory: "اسم البطاقة غير إلزامي",
    isCardTraceNoNotMandatory: "رقم التتبع غير إلزامي",
    isDeleteSentOrderReasonNotMandatory: "سبب حذف الطلب المرسل غير إلزامي",
    isCancelOrderReasonNotMandatory: "سبب إلغاء الطلب غير إلزامي",
    isPrintCancelOrderDoc: "طباعة مستند إلغاء الطلب عند حذف الطلب المرسل",
    splitBillByItem: "Allow Split Bill by Item",
    enableTips: "تفعيل الإكراميات",
    enableTipsHint: "تسجيل إكراميات العملاء (نقدًا/بطاقة) في نافذة الدفع",
    isPrintBillOnQuickOrder: "طباعة الفاتورة",
    isSendFoodOnQuickOrder: "إرسال نوع منتج الطعام",
    isSendBeverageOnQuickOrder: "إرسال نوع مشروب الطلب",
    isSendOthersOnQuickOrder: "إرسال طلب نوع منتج آخر",
    isSendTobaccoOnQuickOrder: "إرسال نوع منتج التبغ",
    showGuestSignatureFieldInPreviewBill: "عرض حقل توقيع الضيف في المعاينة",
    showRoomNoFieldInPreviewBill: "عرض حقل رقم الغرفة في المعاينة",
    showTipFieldInPreviewBill: "عرض حقل الإكرامية في المعاينة",
    font: "خط",
    textBold: "نص عريض",
    sendOrderPrintSettings: "إعدادات طباعة الطلب",
    amountOfBillToPrintOnProcessingPayment: "مبلغ نسخة الفاتورة قيد معالجة الدفع",
    isMultiplePaymentGroupedByType: "مدفوعات متعددة مجمعة حسب نوع الدفع",
    billPrintShowGuestPaymentAmountOnCash: "عرض مبلغ دفع الضيف عند الدفع النقدي",
    billPrintLogoWidth: "عرض الشعار (بالنقاط)",
    showGuestNameInSendOrder: "عرض اسم الضيف في إرسال الطلب",
    allowZeroCover: "السماح بتغطية صفر",
    defaultItem: "افتراضي {item}",
    serialNo: "رقم السيريال",
    stnSn: "رقم STN",
    layoutCSalesInvoiceStatement: "بيان فاتورة مبيعات التنسيق C",
    showManualOrNumber: "عرض يدوي أو رقم (نقدي وبطاقة)",
    allowPackageMemberDiscount: "السماح بالخصم لعناصر أعضاء الحزمة",
    packageGroupName: "اسم مجموعة الحزمة",
    birZCounterSeries: "BIR Z Counter Series",
    articleArticleGroupId: "معرف مجموعة العناصر",
    showPackageOrderDetailPrice: "عرض تفاصيل سعر طلب الطرد",
    hideTaxInLayoutCommonD: "إخفاء ضريبة القيمة المضافة ورسوم الخدمة",
    hideTaxInLayoutCommonDHint: "للتخطيط الشائع د (كمبودي) فقط",
    billPrintCombineTaxLines: "دمج الضريبة والضريبة الإضافية في سطر واحد",
    billPrintCombineTaxLinesHint: "يطبع كل بنود الضريبة باستثناء رسوم الخدمة في سطر واحد على الفاتورة",
    billOperatorName: "اسم المشغّل (تُدار بواسطة)",
    billOperatorNameHint: "للتنسيق Common C: يُطبع تحت اسم الفندق. اتركه فارغًا لعدم الطباعة",
    useMenuTags: "استخدم علامات القائمة",
    billShowRoomName: "عرض اسم الغرفة بدلاً من رقم الغرفة في الفاتورة",
    askPinOnDeleteOrVoid: "اطلب الرقم السري عند حذف الطلبات المرسلة أو إلغائها",
  },
  printer: {
    identifyThisDeviceAsX: "حدد هذا الجهاز كـ {x}",
    unassignThisDeviceFromX: "إلغاء تخصيص هذا الجهاز من {x}",
    overrideAndAssignThisDeviceAsX: "تجاوز الجهاز المعين وجعل هذا الجهاز كـ {x}",
    thisDeviceIsX: "الجهاز هو {x}",
    testPrint: "طباعة اختبار",
    testPrintContent: "محتوى الاختبار",
    testPrintSettings: "إعدادات الطباعة",
    sendTestPrint: "إرسال طباعة اختبار",
    resetToDefault: "إعادة تعيين إلى الافتراضي",
    testPrintSent: "تم إرسال طباعة الاختبار",
    testPrintFailed: "فشل اختبار الطباعة",
    testPrintNoAgent: "لا يوجد مضيف SentecAgent أو عنوان URL للطابعة مكون لهذه الطابعة",
  },
  printerType: {
    printerName: "اسم الطابعة",
    paperWidth: "عرض الورق (مم)",
    paperHeight: "ارتفاع الورق (مم)",
    isSupportExternal: "هل الدعم خارجي",
  },
  price: {
    currentBasePrice: "سعر الأساس الحالي",
    currentPPVATSetupPrice: "إعداد ضريبة القيمة المضافة لفترة السعر الحالية",
    currentAGOVATSetupPrice: "إعداد ضريبة القيمة المضافة لمجموعة المقالات الحالية",
    vatPriceSetupCode: "رمز إعداد سعر ضريبة القيمة المضافة",
    vatAGOSetupCode: "رمز إعداد مجموعة مواد ضريبة القيمة المضافة",
    currentExemptedVATSetupPrice: "سعر إعداد ضريبة القيمة المضافة المعفاة الحالي",
    vatExemptedSetupCode: "رمز إعداد معفى من ضريبة القيمة المضافة",
    articleArticleGroupId: "معرّف مجموعة المقالات",
    changeWillBeAppliedToNPricePeriods: "سيتم تطبيق التغييرات على {n} فترات سعرية",
    batchUpdateWarningNote: "لتحديث بيانات السعر، حدد \"تحديث السعر\" وأدخل قيمة جديدة. املأ الحقول الأخرى حسب الحاجة. اترك أي حقل فارغًا للاحتفاظ بالقيمة الحالية.",
    showOnFbMenu: "عرض في قائمة فيسبوك",
    batchShowOnFbMenu: "رؤية قائمة فيسبوك",
    bulkShowOnFbMenu: "عرض في قائمة QR",
    bulkHideFromFbMenu: "إخفاء من قائمة QR",
    subRecipe: "وصفة فرعية",
    addSubRecipe: "إضافة وصفة فرعية",
  },
  generalSetup: {
    printDeletedSentOrder: "طباعة الطلب المرسل المحذوف",
    showNFCIconInToolbar: "عرض أيقونة NFC في شريط الأدوات",
    showQuickOrderIconInToolbar: "عرض أيقونة الطلب السريع في شريط الأدوات",
    showQuickOrderInMenu: "عرض الطلب السريع في القائمة",
    hideTableNumberInTableList: "إخفاء رقم الطاولة في قائمة الطاولات",
    showValidityAcknowledgmentCertificateStatement: "عرض بيان صلاحية إقرار الشهادة",
    billCopyWording: "نسخة الفاتورة",
    customerTaxIdentifierText: "معرّف ضريبة العميل (افتراضي 'رقم تعريف العميل')",
    sendOrderToScreens: "إرسال الطلب إلى الشاشات",
    systemInfo: "معلومات النظام",
    systemName: "اسم النظام",
    systemVatRegTin: "رقم التسجيل الضريبي لنظام القيمة المضافة",
    vatRegTin: "رقم تسجيل ضريبة القيمة المضافة",
    systemAccrNo: "رقم استحقاق النظام",
    accrNo: "رقم الاعتماد",
    dateIssued: "تاريخ الإصدار",
    validUntil: "صالح حتى",
    systemAccrIssuedDate: "تاريخ إصدار الاعتماد النظامي",
    systemAccrValidUntil: "تاريخ انتهاء الاعتماد",
    systemPtuNo: "رقم نظام PTU",
    ptuNo: "رقم PTU",
    systemAddress: "عنوان النظام",
    systemPtuIssuedDate: "تاريخ إصدار نظام PTU",
    useMenuTags: "استخدام علامات القائمة",
  },
  faq: {
    call: "هل لديك أسئلة أخرى؟ يرجى التواصل",
  },
  ecommerce: {
    products: "المنتجات",
    filters: "الفلاتر",
    collections: "المجموعات",
    priceRange: "نطاق السعر",
    customerReviews: "آراء العملاء",
    up: "وما فوق",
    brand: "علامة تجارية",
    search: "ابحث عن منتج",
    results: "النتائج ( {0} من {1} )",
    orders: "الطلبات",
    shipping: "الشحن",
    freeShipping: "شحن مجاني",
    inStock: "متوفر",
    quantity: "الكمية",
    addToCart: "أضف إلى السلة",
    buyNow: "اشترِ الآن",
    price: "السعر",
    about: "حول هذا العنصر",
    description: "الوصف",
    reviews: "المراجعات",
    details: "تفاصيل المنتج",
    cart: "عربة التسوق",
    summary: "ملخص الطلب",
    total: "الإجمالي",
    discount: "خصم",
    subtotal: "المجموع الفرعي",
    continue: "متابعة التسوق",
    checkout: "الدفع",
  },
  intercompanyMapping: {
    sourceHotel: "فندق المصدر",
    targetHotel: "فندق الهدف",
    sourceArticle: "المقالة المصدر",
    targetArticle: "المقال المستهدف",
    sourceArticleGroup: "مجموعة المقالات المصدرية",
    targetArticleGroup: "مجموعة المقالات المستهدفة",
    asSource: "كمصدر",
    asTarget: "كما هو مستهدف",
    mapping: "تخطيط",
    intercompanyArticleMapping: "تعيين المواد بين الشركات",
    intercompanyArticleGroupMapping: "تعيين مجموعة مقالات الشركات",
    checkTargetOutletStatus: "تخطيط بين الشركات: تحقق من حالة المنفذ المستهدف",
    createIntercompanyMappingEntries: "تخطيط الشركات: إنشاء إدخالات تخطيط الشركات",
    productTypesToTransfer: "أنواع المنتجات للنقل",
    defaultPayment: "الدفع الافتراضي المستهدف",
    defaultComplimentaryPayment: "دفعة الإكرامية الافتراضية للهدف",
    defaultCollectionIdentification: "تعريف التحصيل الافتراضي للهدف",
    defaultOutlet: "المنافذ الافتراضية المستهدفة",
    defaultTable: "جدول الهدف الافتراضي",
    sourceOutlet: "منفذ المصدر",
    sourceArticleProductType: "نوع منتج المقالة المصدر",
    prefix: "بادئة الهدف",
    checkSourceOutletStatus: "تخطيط بين الشركات: التحقق من حالة المنفذ المصدر",
  },
  menu: {
    rateManagement: "إدارة الأسعار",
    reservation: "حجز",
    reservationNew: "جديد",
    reservationList: "قائمة",
    frontOffice: "المكتب الأمامي",
    generalSettings: "الإعدادات العامة",
    guestTitle: "لقب الضيف",
    guestDocumentType: "نوع وثيقة الضيف",
    manageHotel: "فندق",
    hotel: "فندق",
    hotelList: "قائمة",
    hotelCategory: "فئة الفندق",
    hotelChain: "سلسلة فنادق",
    marketSegment: "شريحة السوق",
    rooms: "الغرف",
    currency: "عملة",
    search: "بحث (اضغط \"ctrl + /\" للتركيز)",
    dashboard: "لوحة التحكم",
    logout: "تسجيل الخروج",
    flushSiteData: "مسح بيانات الموقع",
    profile: "الملف الشخصي",
    blank: "صفحة فارغة",
    pages: "الصفحات",
    others: "آخرون",
    email: "البريد الإلكتروني",
    chat: "دردشة",
    todo: "المهام",
    board: "لوحة المهام",
    users: "المستخدمون",
    usersList: "قائمة",
    usersEdit: "تعديل",
    ecommerce: "تجارة إلكترونية",
    ecommerceList: "المنتجات",
    ecommerceProductDetails: "تفاصيل المنتج",
    ecommerceOrders: "طلبات",
    ecommerceCart: "عربة التسوق",
    auth: "صفحات المصادقة",
    authLogin: "تسجيل الدخول",
    authRegister: "تسجيل",
    authVerify: "تحقق من البريد الإلكتروني",
    authForgot: "نسيت كلمة المرور",
    authReset: "إعادة تعيين كلمة المرور",
    errorPages: "صفحات الخطأ",
    errorNotFound: "غير موجود / 404",
    errorUnexpected: "غير متوقع / 500",
    utilityPages: "صفحات الخدمة",
    utilityMaintenance: "صيانة",
    utilitySoon: "قريباً",
    utilityHelp: "الأسئلة الشائعة / المساعدة",
    levels: "مستويات القائمة",
    disabled: "القائمة معطلة",
    docs: "التوثيق",
    feedback: "ملاحظات",
    support: "دعم",
    tables: "الجداول",
    orderHistories: "سجلات الطلبات",
    all: "الكل",
    closed: "مغلق",
    open: "فتح",
    deletedSentOrders: "الطلبات المرسلة المحذوفة",
    deletedOrderPayments: "مدفوعات الطلبات المحذوفة",
    transferOrderHistory: "تاريخ طلبات التحويل",
    closedDays: "أيام مغلقة",
    screens: "الشاشات",
    masterData: "البيانات الأساسية",
    outlet: "منفذ",
    generalSetup: "الإعدادات العامة",
    parameter: "معامل",
    table: "جدول",
    articleProductType: "نوع منتج المقالة",
    article: "مقالة",
    articleGroup: "مجموعة المقالات",
    articleGroupSetup: "إعداد مجموعة المقالات",
    articleGroupOutletSetup: "إعداد مجموعة منافذ المقالات",
    articleFlavourGroup: "مجموعة نكهة المقال",
    articleFlavour: "نمط المقال",
    articleFlavourGroupArticleGroupSetup: "إعداد مجموعة نكهة المقالات",
    collectionCategory: "فئة المجموعة",
    collectionType: "نوع المجموعة",
    collectionIdentificationGroup: "مجموعة تعريف المجموعة",
    collectionIdentification: "تحديد المجموعة",
    collectionTypeOutletSetup: "إعداد نوع مجموعة المنافذ",
    price: "السعر",
    discount: "خصم",
    printer: "طابعة",
    screen: "شاشة",
    agent: "عميل",
    banquet: "وليمة",
    banquetGroupList: "قائمة مجموعات الولائم",
    banquetReservationList: "قائمة حجوزات الولائم",
    banquetReservationCalendar: "تقويم حجوزات الولائم",
    reports: "التقارير",
    masterAccount: "الحساب الرئيسي",
    incomeAudit: "تدقيق الدخل",
    outletStatus: "حالة المنفذ",
    manageNfcBracelet: "إدارة سوار NFC",
    taxInterfaceIntegrationLog: "سجل تكامل واجهة الضرائب",
    workingDay: "يوم عمل",
    index: "فهرس",
    printerType: "نوع الطابعة",
    quickOrder: "طلب سريع",
    mealTimeSetup: "إعداد وقت الوجبة",
    tableReservation: "حجز طاولة",
    breakfastRegistration: "تسجيل الإفطار",
    mealRegistration: "تسجيل الوجبة",
    roomBreakfastRegistration: "تسجيل إفطار الغرفة",
    roomLunchRegistration: "تسجيل غداء الغرفة",
    roomDinnerRegistration: "تسجيل عشاء الغرفة",
    banquetLunchRegistration: "تسجيل غداء المأدبة",
    banquetDinnerRegistration: "تسجيل عشاء الوليمة",
    itemLoan: "إعارة عنصر",
    courseStage: "مرحلة الدورة",
    waiter: "النادل",
    intercompanyMapping: "تخطيط الشركات المشتركة",
    fbMenuOrderRequest: "طلب ترتيب القائمة في فيسبوك",
    fbMenuConfiguration: "إعدادات قائمة الطعام والمشروبات",
    guestProfiles: "ملفات الضيوف",
    tableLabelManagement: "إدارة تسميات الجداول",
    maintenanceRequest: "طلب صيانة",
    package: "حزمة",
    captainOrder: "طلب القبطان",
    workingDate: "تاريخ العمل",
  },
  localCommon: {
    dimensionSetup: "إعداد الأبعاد",
    dimensionSetupSaved: "تم حفظ إعداد الأبعاد بنجاح!",
    dimensionSetupDeleted: "تم حذف إعداد الأبعاد بنجاح!",
    dashboardWithItem: "لوحة التحكم {item}",
    top10ItemsSoldWithItem: "أفضل 10 عناصر مباعة - {item}",
    openDay: "يوم مفتوح",
    closeDay: "إغلاق اليوم",
    hostURLIPAddress: "رابط المضيف / عنوان IP",
    roomRevenueBreakdown: "تفصيل إيرادات الغرف",
    inHouseList: "قائمة داخلية",
    to: "إلى",
    unknown: "غير معروف",
    customDate: "تاريخ مخصص",
    itemLoan: "إعارة عنصر",
    maintenanceRequestReport: "تقرير طلب الصيانة",
    printCancellationDocument: "طباعة مستند الإلغاء",
    allowOverLimit: "السماح بتجاوز الحد",
    allowOverLimitDesc: "في حال التفعيل، يمكن أن تتجاوز المعاملات الرصيد المتاح.",
    allowOverLimitWarning: "سيتم تنفيذ المعاملات التي تتجاوز الحد ومع ذلك سيعرض النظام إشعارًا بتجاوز الحد.",
    collectionIdentification: "تحديد المجموعة",
    continue: "استمر",
    creditBalanceAmount: "رصيد الائتمان",
    creditBalanceAmountDesc: "الحد الأقصى للاستخدام في الشهر.",
    creditBalancePositive: "يجب أن يكون رصيد الائتمان أكبر من صفر",
    critical: "حرج",
    currentBalance: "الرصيد الحالي",
    currentBalanceDesc: "الحد المتبقي المتاح في الشهر الحالي (يحسبه النظام).",
    limitExhausted: "تم استنفاد الحد",
    monthlyCreditLimit: "الحد الائتماني الشهري",
    monthlyCreditLimitSubtitle: "ينطبق الحد على الشهر الحالي بناءً على المعاملات المرحّلة.",
    nearLimit: "قريب من الحد",
    normal: "عادي",
    ok: "حسناً",
    overLimit: "تجاوز الحد",
    totalUsedBalance: "الرصيد المستخدم الكلي",
    totalUsedBalanceDesc: "إجمالي الاستخدام في الشهر الحالي (يحسبه النظام).",
    warning: "تحذير",
  },
  button: {
    add: "أضف",
  },
  collectionType: {
    oneCollectionTypePerCategoryPerOutlet: "يرجى التأكد من أن كل منفذ لديه نوع مجموعة واحد على الأقل لكل فئة مجموعة. لفئة مجموعة الأساور، يجب أن يحتوي كل منفذ على نوع مجموعة واحد بالضبط.",
  },
  articleGroupOutlet: {
    saveArticleGroupOutletBeforeAddingRevenueCenterMealTime: "يرجى حفظ إعداد مجموعة مق outlets قبل إضافة مركز إيرادات وقت الوجبة",
    confirmRevenueCenterInternalUserChange: "سيؤدي هذا الإجراء إلى تحديث إعداد مركز الإيرادات لمجموعة المقالات المحددة. لن تمنع المعاملات الحالية المرتبطة بمجموعة المقالات هذه التغيير. هل تريد المتابعة؟",
    confirmVATPostingGroupInternalUserChange: "سيؤدي هذا الإجراء إلى تحديث مجموعة ترحيل ضريبة القيمة المضافة لمجموعة المقالات المحددة. لن تمنع المعاملات الحالية المرتبطة بمجموعة المقالات هذه التغيير. هل تريد المتابعة؟",
    exemptedVATPostingGroup: "مجموعة ترحيل ضريبة القيمة المضافة المعفاة",
  },
  tableReservation: {
    seats: "المقاعد",
    cantReserveForDateBeforeTodayWorkingDate: "لا يمكن الحجز لتاريخ قبل تاريخ العمل اليوم",
    tableReservedFromXtoY: "المائدة محجوزة لـ {x} إلى {y}",
    cantEditCompleted: "لا يمكن تعديل حجز الطاولة المكتمل",
    cantCancelCompleted: "لا يمكن إلغاء حجز الطاولة المكتمل",
    cantDeleteCompleted: "لا يمكن حذف حجز الطاولة المكتمل",
    cantEditCanceled: "لا يمكن تعديل حجز الطاولة الملغي",
    cantCancelCanceled: "لا يمكن إلغاء حجز الطاولة الملغى",
  },
  breakfastRegistration: {
    breakfastRegistration: "تسجيل الإفطار",
    outletClosed: "المتجر مغلق",
    noGuest: "لا ضيف",
    allGuestRegistered: "جميع الضيوف المسجلين بالفعل في هذه الغرفة",
    selectedGuestAlreadyRegistered: "الضيف المحدد مسجل بالفعل",
    readingCard: "بطاقة القراءة",
    guestRegistered: "تم تسجيل الضيف",
    readCard: "اقرأ البطاقة",
    registerGuest: "تسجيل ضيف",
    undoRegisterGuest: "تراجع عن تسجيل الضيف",
    chooseGuestToUnregister: "يرجى اختيار الضيف لإلغاء التسجيل",
    cantUnregisterWhosNotRegistered: "لا يمكن إلغاء تسجيل ضيف غير مسجل.",
    roomNotFoundInList: "الغرفة غير موجودة في القائمة.",
  },
  mealRegistration: {
    totalExpected: "الإجمالي المتوقع",
    totalActual: "الإجمالي الفعلي",
    totalVariance: "إجمالي التباين",
    totalBanquetReservation: "إجمالي حجز الوليمة",
    undoRegister: "إلغاء التسجيل",
    numberOfGuest: "عدد الضيوف",
    expected: "متوقع",
    actual: "فعلي",
    cardOutsideBanquetWindow: "{status}: Guest stay ({guestCheckIn} - {guestCheckOut}) is outside banquet time ({banquetStart} - {banquetEnd}).",
  },
  reports: {
    includeComplimentary: "تضمين مجاني",
    showVATBreakdown: "عرض تفاصيل ضريبة القيمة المضافة",
    posSalesByHour: "مبيعات نقاط البيع حسب الساعة",
    posSalesByHourReport: "تقرير مبيعات نقاط البيع حسب الساعة",
    posSalesByCategory: "مبيعات نقاط البيع حسب الفئة",
    posSalesByCategoryReport: "تقرير مبيعات نقاط البيع حسب الفئة",
    posInventoryAndStock: "جرد المخزون",
    posInventoryAndStockReport: "تقرير المخزون والمخزون لنقاط البيع",
    salesPerfomanceAndAnalysis: "أداء المبيعات والتحليل",
    hospitalityAndServiceInteraction: "الضيافة وتفاعل الخدمة",
    transactionAndCashierManagement: "إدارة المعاملات والصرافة",
    inventoryAndOperationalManagement: "إدارة المخزون والعمليات",
    bottomSalesByArticleReport: "تقرير المبيعات الأقل حسب المقال",
    posBottomSalesByArticle: "تقرير مبيعات نقاط البيع حسب المادة",
    reportName: "اسم التقرير",
    salesPerformanceAndAnalysis: "أداء المبيعات والتحليل",
    showAllTime: "عرض كل الوقت",
    paymentTotal: "إجمالي المدفوعات",
    totalIncludingTips: "الإجمالي شامل الإكراميات",
    zReport: "تقرير نقطة البيع Z",
    xReport: "تقرير نقطة البيع X",
    cashier: "أمين الصندوق",
    posSalesByTableLabelReport: "تقرير مبيعات نقاط البيع حسب ملصق الطاولة",
    posSalesByTableLabel: "تقرير مبيعات نقاط البيع حسب الطاولة",
    salesSummaryByPackageReport: "ملخص المبيعات حسب تقرير الحزمة",
    packageCode: "رمز الطرد",
    packageName: "اسم الحزمة",
    packageRevenue: "إيرادات الحزمة",
    packageQuantity: "كمية الطرد",
    avgPackagePrice: "متوسط سعر الحزمة",
    topPackage: "الباقة المميزة",
    numberOfPackages: "عدد الطرود",
    averagePrice: "السعر المتوسط",
    contributionPct: "% المساهمة",
    contributionPctFromTotalRevenue: "نسبة المساهمة من إجمالي الإيرادات",
    packageBreakdown: "تفاصيل الباقة",
    posProductionByWaiter: "إنتاج نقاط البيع بواسطة النادل",
    posProductionByWaiterReport: "تقرير إنتاج نقاط البيع بواسطة النادل",
    reportType: "نوع التقرير",
    asOfDate: "تاريخ السريان",
    customRange: "نطاق مخصص",
    quickSelect: "اختيار سريع",
    waiterCode: "نادل",
    waiters: "النُدُل",
    productionBreakdownFor: "تفاصيل الإنتاج لـ {waiter} ({period})",
    unassigned: "غير مُعين",
    birSCDiscountReport: "تقرير خصم كبار السن BIR",
    birPWDDiscountReport: "تقرير خصم BIR PWD",
    showFnbRevenue: "عرض إيرادات الطعام والشراب",
    printPdfLandscape: "طباعة PDF بشكل أفقي",
    showScPwdNames: "عرض أسماء كبار السن/ذوي الإعاقة",
    creditMemoVoidReport: "تقرير إشعارات الدائن / الإلغاءات",
    documentType: "نوع المستند",
    documentTypeCreditMemo: "إشعار دائن",
    documentTypeVoid: "إلغاء",
    documentTypeBoth: "كلاهما",
    type: "النوع",
    originalInvoiceNo: "رقم الفاتورة الأصلية",
    originalWorkingDate: "تاريخ العمل الأصلي",
    voidReason: "سبب الإلغاء",
    posSalesByHourBreakdown: "مبيعات نقاط البيع حسب الساعة",
    breakdownTotal: "إجمالي التفصيل",
  },
  taxIntegrationLog: {
    decodeDocumentPayloadIntoJSON: "فك تشفير محتوى الوثيقة إلى JSON",
  },
  screen: {
    new: "جديد",
    inProgress: "قيد التحضير",
    ready: "جاهز للتقديم",
    done: "تم التقديم",
    table: "طاولة",
    orderNumber: "طلب رقم",
    sentBy: "أُرسل بواسطة",
    sinceOrderWasSent: "منذ دقيقة واحدة | منذ {{minute}} دقائق",
    todaysFinishedOrders: "الطلبات المنجزة اليوم",
    posScreenOrdersReport: "تقرير طلبات شاشة نقاط البيع",
    captainOrder: "Captain Order",
    printer: "طابعة",
    action: "إجراء",
    reprintQuestion: "إعادة الطباعة؟",
    reprint: "إعادة الطباعة",
    lastPrinted: "آخر طباعة",
    batch: "دفعة",
    search: "بحث",
    reprintAll: "الكل",
    reprintYes: "نعم",
    reprintNo: "لا",
    popupBlocked: "تم حظر النافذة المنبثقة. اسمح بالنوافذ المنبثقة لهذا الموقع للطباعة.",
    coReprint: "CO إعادة طباعة {count}",
    markAllReady: "وضع علامة جاهز للكل",
    markSelectedReady: "وضع علامة جاهز للمحدد ({count})",
  },
  articleProductType: {
    discountRevenueCenter: "مركز إيرادات الخصم",
    perLineDiscountsWillUseTheSelectedRevenueCenter: "ستستخدم الخصومات لكل سطر مركز الإيرادات المحدد.",
    toEnableThisFeatureMakeSureDiscountAndAllowanceActiveInPOSParameter: "لتفعيل هذه الميزة، تأكد من تفعيل خصومات وبدلات في معلمات نقطة البيع.",
  },
  contactPerson: {
    contactPerson: "شخص الاتصال",
    successCreate: "تم إنشاء جهة الاتصال بنجاح.",
  },
  agency: {
    successCreate: "تم إنشاء الوكالة بنجاح.",
    successUpdate: "تم تحديث الوكالة بنجاح.",
  },
  client: {
    successCreate: "تم إنشاء العميل بنجاح.",
    successUpdate: "تم تحديث العميل بنجاح.",
  },
  clientComposition: {
    successCreate: "تم إنشاء تركيبة العميل بنجاح.",
    successUpdate: "تم تحديث تكوين العميل بنجاح.",
    warningChangeIsLedgerAllowed: "تحتاج إلى إذن لتغيير \"هل يُسمح بالسجل",
    noLimit: "لا حدود",
    setLimit: "حدد الحد",
    currentAging: "الرصيد المتقادم الحالي",
    todayLedger: "دفتر اليوم",
    totalUsedBalance: "الرصيد المستخدم الكلي",
    availableCredit: "الرصيد المتاح",
  },
  $vuetify: {
    badge: "شارة",
    close: "إغلاق",
    loading: "جاري التحميل...",
    dataIterator: {
      noResultsText: "لم يتم العثور على سجلات مطابقة",
      loadingText: "جاري تحميل العناصر...",
    },
    dataTable: {
      itemsPerPageText: "صفوف لكل صفحة:",
      ariaLabel: {
        sortDescending: "تم الترتيب تنازليًا.",
        sortAscending: "تم الترتيب تصاعديًا.",
        sortNone: "غير مرتب.",
        activateNone: "اضغط لإزالة الترتيب.",
        activateDescending: "اضغط للترتيب تنازليًا.",
        activateAscending: "اضغط للترتيب تصاعديًا.",
      },
      sortBy: "ترتيب حسب",
    },
    dataFooter: {
      itemsPerPageText: "عناصر لكل صفحة:",
      itemsPerPageAll: "الكل",
      nextPage: "الصفحة التالية",
      prevPage: "الصفحة السابقة",
      firstPage: "الصفحة الأولى",
      lastPage: "الصفحة الأخيرة",
      pageText: "{0}-{1} من {2}",
    },
    datePicker: {
      itemsSelected: "{0} محدد",
      nextMonthAriaLabel: "الشهر التالي",
      nextYearAriaLabel: "السنة التالية",
      prevMonthAriaLabel: "الشهر السابق",
      prevYearAriaLabel: "السنة السابقة",
    },
    noDataText: "لا توجد بيانات متاحة",
    carousel: {
      prev: "العرض السابق",
      next: "العرض التالي",
      ariaLabel: {
        delimiter: "شريحة {0} من {1}",
      },
    },
    calendar: {
      moreEvents: "{0} المزيد",
    },
    fileInput: {
      counter: "{0} ملفات",
      counterSize: "{0} ملفات ({1} إجمالي)",
    },
    timePicker: {
      am: "ص",
      pm: "م",
    },
    pagination: {
      ariaLabel: {
        wrapper: "تنقل الصفحات",
        next: "الصفحة التالية",
        previous: "الصفحة السابقة",
        page: "انتقل إلى الصفحة {0}",
        currentPage: "الصفحة الحالية، صفحة {0}",
      },
    },
    input: {
      clear: "محو",
      prependAction: "{0} إجراء مسبق",
      appendAction: "{0} إجراء ملحق",
    },
  },
  fbMenuConfiguration: {
    title: "إعدادات قائمة الطعام والمشروبات",
  },
  fbMenuOrderRequest: {
    def: "طلب قائمة الطعام",
    open: "فتح طلب قائمة الطعام",
    closed: "طلبات قائمة الطعام المغلقة",
    all: "جميع طلبات قائمة الطعام",
    chooseTable: "اختر الطاولة",
    orderCreatedFromRequest: "تم إنشاء الطلب من طلب قائمة الطعام والمشروبات",
    posMenuQRCode: "رمز الاستجابة السريعة لقائمة الطعام في نظام نقاط البيع",
    guestRoomTable: "طاولة الغرفة للضيوف",
    assignTable: "تعيين الطاولة",
    currentlyOccupiedByGuestName: "مشغول حالياً بواسطة اسم الضيف",
    confirmOrderCancelTitle: "إلغاء الطلب",
    confirmOrderCancelBody: "هل أنت متأكد أنك تريد إلغاء الطلب؟",
    confirmUndoOrderCancelTitle: "تراجع إلغاء الطلب",
    confirmUndoOrderCancelBody: "هل أنت متأكد أنك تريد التراجع عن إلغاء الطلب؟",
    orderHasBeenCancelled: "تم إلغاء الطلب",
    orderHasBeenUndoCancel: "تم استعادة الطلب",
    auditLog: {
      title: "سجل التدقيق",
      guest: "ضيف",
      columns: {
        created: "متى",
        type: "الإجراء",
        createdBy: "بواسطة",
        description: "الوصف",
      },
      types: {
        CREATE: "تم إنشاء الطلب",
        ASSIGN_TABLE: "تم تعيين الطاولة",
        CANCEL_BY_ADMIN: "ألغاه المسؤول",
        UNDO_CANCEL: "تم التراجع عن الإلغاء",
      },
    },
    guestQR: "رمز الاستجابة السريعة للزوار",
    guestQRHint: "أظهر هذا للضيف. المسح يسمح لهم بالطلب من هذه الطاولة مباشرةً في الفاتورة.",
    guestQRPrintPopupBlocked: "تم حظر النافذة المنبثقة. السماح بالنافذة المنبثقة لهذا الموقع لطباعة رمز الاستجابة السريعة.",
    guestQRPrintFailed: "تعذر إعداد رمز الاستجابة السريعة للطباعة.",
    scanMeToOrder: "امسحني للطلب",
    dynamicQRDisabled: "رمز الاستجابة السريعة الديناميكي معطل لهذا الفندق",
  },
  package: {
    fieldRequired: "الحقل مطلوب",
    codeRequired: "الكود مطلوب",
    codeMaxLength: "يجب ألا يزيد طول الكود عن 10 أحرف",
    codeAlreadyUsed: "الكود {code} مستخدم بالفعل.",
    saveSuccess: "تم {action} {title} {code}.",
    saveFailed: "تعذر {action} {title} {code}.",
    actionSaved: "تم الحفظ",
    actionUpdated: "تم التحديث",
    confirmRemoveItems: "هل أنت متأكد أنك تريد إزالة العناصر المحددة؟",
    deleteTitle: "حذف",
    deleteSuccess: "تم حذف العنصر(العناصر).",
    deleteFailed: "فشل في حذف العنصر(العناصر) المحدد.",
    addOutletSuccess: "تمت إضافة الفرع إلى الحزمة {code}.",
    addOutletFailed: "تعذر إضافة الفرع إلى الحزمة {code}.",
    addArticleSuccess: "تمت إضافة المقالة إلى الحزمة {code}.",
    addArticleFailed: "تعذر إضافة المقالة إلى الحزمة {code}.",
    showPackageOrderDetailPriceMode: "إظهار سعر تفاصيل طلب الحزمة",
    packageOrderDetailPriceModeFollowParameter: "اتباع إعدادات POS",
    packageOrderDetailPriceModeForceShow: "تجاوز: إظهار",
    packageOrderDetailPriceModeForceHide: "تجاوز: إخفاء",
    itemsLabel: "تم اختيار {count} عنصر",
    remove: "إزالة",
    assignOutlet: "تعيين فرع",
    assignArticle: "تعيين مقالة",
    saveBeforeManagingRelations: "احفظ الحزمة قبل إدارة الفروع أو المقالات.",
    emptyPreviewResponse: "لم تعرض معاينة الحزمة أي محتوى.",
    noArticlesInPreview: "لا توجد مقالات لإضافتها في الحزمة.",
    showPackageDetailOnInvoice: "إظهار تفاصيل الحزمة في الفاتورة",
  },
  tag: {
    title: "العلامات",
    tag: "علامة",
    parent: "الأصل",
    parents: "الأصول",
    navigate: "التنقل",
    tagsNavigation: "التنقل بين العلامات",
    revenueCenterNotSet: "العنصر ليس لديه مركز إيرادات",
    submenu: "قائمة فرعية",
    home: "الرئيسية",
    menuHasNotBeenSetup: "القائمة لم يتم إعدادها",
    removeNItems: "إزالة {n} عنصر(عناصر)",
    nItems: "{n} عنصر",
    seeArticleLocations: "عرض مواقع المقالات",
    articleLocations: "مواقع المقالات",
    seeArticleGroups: "عرض مجموعات المقالات",
    seeMenuTags: "عرض علامات القائمة",
  },
  tableLabelManagement: {
    accessibility: "إمكانية الوصول",
    addLabel: "إضافة تسمية",
    allCategories: "جميع الفئات",
    allowMultipleHint: "عند التفعيل، يمكن أن تحتوي الجداول على تسميات متعددة من هذه الفئة (مثل: \"إطلالة على المحيط\" + \"إطلالة على المسبح\"). عند إلغاء التفعيل، يُسمح بتسمية واحدة فقط (مثل: \"داخلية\" أو \"خارجية\").",
    allowMultipleLabels: "السماح بتحديد علامات متعددة من هذه الفئة",
    allowMultipleSingleInfo: "الفئات المعلمة كـ \"اختر واحد\" تسمح بتسمية واحدة فقط لكل جدول، بينما الفئات \"السماح بعدة\" تتيح لك تعيين تسميات متعددة من تلك الفئة.",
    appliedLabels: "التسميات المطبقة",
    category: "الفئة",
    categoryDescriptionContent: "الفئات تجمع التسميات ذات الصلة معًا. على سبيل المثال، \"الموقع الفعلي\" هو فئة تحتوي على تسميات مثل داخلي، خارجي، فناء، إلخ.",
    categoryDescriptionTitle: "ما هي الفئات؟",
    categoryGroup: "مجموعة الفئات",
    categoryGroupHelp: "اجمع الفئات المماثلة معًا في واجهة المستخدم",
    categoryName: "اسم الفئة",
    chooseAColorThatMakesThisLabelEasyToIdentify: "اختر لونًا يسهل التعرف على هذا الملصق.",
    clearLabelsFilter: "مسح فلتر التصنيفات",
    climateControl: "تحكم المناخ",
    createNewCategory: "إنشاء فئة جديدة",
    createNewCategoryDescription: "أضف فئة تسمية مخصصة لجداولك",
    createNewLabel: "إنشاء تسمية جديدة",
    createNewLabelDescription: "أضف تسمية مخصصة لتصنيف جداولك",
    customLabels: "التسميات المخصصة",
    description: "الوصف",
    editCategory: "تعديل الفئة",
    editLabel: "تعديل التسمية",
    environment: "البيئة",
    examples: "أمثلة",
    familyFeatures: "ميزات العائلة",
    filterByLabels: "تصفية حسب العلامات",
    guest: "ضيف",
    importSystemLabels: "استيراد تسميات النظام",
    labelColor: "لون التسمية",
    labelDescriptionContent: "التسميات هي سمات محددة يمكنك تعيينها للجداول. على سبيل المثال، ضمن فئة \"الموقع الفيزيائي\"، قد تكون لديك تسميات مثل \"داخلي\"، \"خارجي\"، \"فناء\"، إلخ.",
    labelDescriptionTitle: "ما هي التسميات؟",
    labelName: "اسم التسمية",
    labels: "التسميات",
    labelsAreSpecificToEachOutlet: "التسميات محددة لكل منفذ",
    labelsInUse: "التسميات المستخدمة",
    manageLabels: "إدارة التسميات",
    managingLabelsFor: "إدارة التسميات لـ",
    modifyCategoryDescription: "تعديل إعدادات فئة '{x}'",
    modifyLabelDescription: "عدل تسمية '{x}'",
    multipleAllowed: "مسموح بعدة",
    multiSelectCategories: "فئات متعددة الاختيار",
    newCategory: "فئة جديدة",
    operational: "تشغيلي",
    ordersLast30d: "الطلبات (30 يوم)",
    organizeAndCustomizeTableLabelsForYourOutlets: "نظم وخصص تسميات الطاولات لمنافذك",
    outlets: "المنافذ",
    physicalLocation: "الموقع الفعلي",
    preview: "معاينة",
    seating: "المقاعد",
    seeLess: "عرض أقل",
    selectionRules: "قواعد الاختيار",
    selectOne: "اختر واحداً",
    service: "الخدمة",
    singleSelectCategories: "فئات اختيار فردي",
    smokingPolicy: "سياسة التدخين",
    sortOrder: "ترتيب الفرز",
    system: "النظام",
    systemCategory: "فئة النظام",
    systemCategoryMessage: "هذه فئة نظام. يمكنك تعديل الإعدادات مثل \"السماح بالتعدد\" و\"عرض المجموعة\"، لكن لا يمكن تغيير اسم الفئة. اعتبر إنشاء فئة مخصصة إذا كنت بحاجة إلى أسماء مختلفة.",
    systemLabel: "تسمية النظام",
    systemLabelMessage: "هذا ملصق نظام. يمكنك تعديل اللون والإعدادات الأخرى، لكن لا يمكن تغيير اسم الملصق. اعتبر إنشاء ملصق مخصص إذا كنت بحاجة إلى اسم مختلف.",
    systemLabels: "تسميات النظام",
    tableLabels: "تصنيفات الطاولات",
    tablesUsing: "الجداول المستخدمة",
    thisCategoryAllowsMultipleLabelsPerTable: "تسمح هذه الفئة بإضافة عدة تسميات لكل جدول.",
    thisCategoryAllowsOnlyOneLabelPerTable: "تسمح هذه الفئة بلصق علامة واحدة فقط لكل جدول.",
    tip: "نصيحة",
    totalCategories: "إجمالي الفئات",
    totalLabels: "إجمالي الملصقات",
    usageStatistics: "إحصائيات الاستخدام",
    usedByXTables: "مستخدم من قبل {x} جدول",
    viewType: "نوع العرض",
    xLabels: "{x} ملصقات",
    xMore: "+{x} المزيد",
    edcMachineIntegration: "تكامل آلة EDC",
    enableEdcMachine: "تفعيل جهاز EDC",
    edcMode: "وضع EDC",
    edcModeAlways: "استخدم EDC دائمًا",
    edcModePrompt: "اطلب من المحاسب الاختيار",
    edcAgentUrl: "رابط وكيل سنتك",
    edcAgentUrlPlaceholder: "اتركه فارغًا لاستخدام رابط pos.agent",
    edcAgentUrlHint: "يعود إلى عنوان URL الخاص بالوكيل إذا لم يتم تعيينه",
    edcAgentToken: "رمز وكيل سنتك",
    edcAgentTokenPlaceholder: "اتركه فارغًا لاستخدام رمز pos.agent",
    edcAgentTokenHint: "يتجاوز رمز الوكيل عند التعيين",
    edcVendor: "بائع EDC",
    edcComPort: "منفذ COM",
    edcComPortPlaceholder: "مثال: COM3",
    edcTestConnection: "اختبار الاتصال",
    edcConnected: "متصل",
    edcFailed: "فشل",
    edcEnterAgentUrlFirst: "يرجى إدخال عنوان URL لوكيل سنتك أولاً.",
    edcPayment: "دفع EDC",
    edcInvoiceAmountRemaining: "المبلغ المتبقي من الفاتورة",
    edcUserPayment: "دفع المستخدم",
    edcTerminalWillReceive: "ستستقبل المحطة: {amount} ({currency} وحدات فرعية)",
    edcChange: "تغيير",
    edcRemainingPayment: "المبلغ المتبقي",
    edcPressPayToInitiate: "اضغط دفع لبدء عملية EDC",
    edcWaitingForCard: "انتظار لمس البطاقة / إدخالها...",
    edcSecondsRemaining: "{ثانية} متبقية",
    edcCancel: "إلغاء",
    edcTransactionApproved: "تمت الموافقة على المعاملة",
    edcTransactionFailed: "فشل المعاملة",
    edcRetry: "إعادة المحاولة",
    edcPayViaEdc: "الدفع عبر EDC",
    edcConfirm: "تأكيد",
    edcCard: "بطاقة",
    edcAuthCode: "رمز التوثيق",
    edcTraceNumber: "تتبع #",
    edcTerminal: "محطة",
    edcTransactionDeclined: "تم رفض المعاملة",
    edcConnectionFailed: "فشل الاتصال بجهاز EDC",
    edcTotalPaymentAlreadyEqual: "إجمالي الدفع يساوي مبلغ الفاتورة بالفعل.",
  },
  orderNotification: {
    newOrderTitle: "طلب جديد",
    newOrderMessage: "طلب جديد من {guest} في {outlet} ({location}) — {count} عناصر، الكمية {qty}",
    orderCanceledMessage: "الطلب #{orderId} من {guest} في {outlet} تم إلغاؤه",
    orderUndoCanceledMessage: "الطلب #{orderId} من {guest} في {outlet} تم التراجع عن الإلغاء",
    orderAssignedToTableMessage: "الطلب #{orderId} من {guest} في {outlet} تم تعيينه إلى طاولة",
  },
  salesDocuments: {
    salesReturnTitle: "مرتجع مبيعات",
    salesRefundTitle: "استرداد مبيعات",
    reasonForRefund: "سبب الاسترداد: {value}",
    authorizer: "المصرح: {value}",
    printSalesReturn: "طباعة مرتجع المبيعات",
    printSalesRefund: "طباعة استرداد المبيعات",
    billPrinterNotConfigured: "لا توجد طابعة فواتير معدة لهذا المنفذ.",
    printAgentNotConfigured: "لا يوجد وكيل طباعة معد لهذا الجهاز.",
  },
  eJournal: {
    typeSalesInvoice: "فاتورة مبيعات",
    typeAcknowledgementReceipt: "إيصال إقرار",
    typeVoid: "إلغاء المستند",
    typeCreditMemo: "إشعار دائن",
    typeCancel: "إلغاء",
    businessName: "اسم النشاط التجاري",
    period: "الفترة",
    createdBy: "أنشأه",
    pdfSaved: "تم حفظ {file} — {pages} صفحة.",
    pdfUnsupportedChars: "لا يمكن لملف PDF إظهار هذه الأحرف: {chars}. ملف .txt الذي تم تنزيله هو النسخة المعتمدة.",
    title: "دفتر BIR الإلكتروني",
    dateFrom: "من تاريخ",
    dateTo: "إلى تاريخ",
    lineWidth: "عرض السطر",
    lineWidthAuto: "فارغ = من إعداد طباعة الفاتورة لكل منفذ",
    lineWidthRange: "أدخل عددًا صحيحًا من {min} إلى {max}، أو اتركه فارغًا لاتباع إعداد طباعة الفاتورة.",
    widthFromSetup: "{outlet}: {width} حرفًا في السطر، من إعداد طباعة الفاتورة.",
    widthChosen: "{outlet}: {width} حرفًا في السطر، حسب الاختيار.",
    widthFromPrintSettings: "{outlet}: {width} حرفًا في السطر، من إعدادات الطباعة.",
    printSingleDayOnly: "الطباعة على طابعة الفواتير لمنفذ واحد ويوم واحد. اختر منفذًا واحدًا واجعل تاريخ البداية والنهاية نفس اليوم.",
    printSettingsTitle: "إعدادات طباعة E-Journal",
    printerTypeUnsupported: "لا يمكن طباعة E-journal على {printer} بعد: هذا النوع من الطابعات يعيد التفاف النص فيختل ترتيبه. اختر طابعة أخرى أو استخدم الطباعة بصيغة PDF.",
    generate: "إنشاء",
    downloadTxt: "تنزيل .txt",
    allOutlets: "جميع المنافذ",
    noPermission: "ليس لديك صلاحية لعرض دفتر BIR الإلكتروني.",
    emptyState: "لم تُصدر مستندات ضريبية لـ {outlet} بين {from} و {to}.",
    progress: "جارٍ إنشاء {outlet} ({n} مستند)...",
    logTitle: "سجل تعديلات نقطة البيع",
    logNoPermission: "ليس لديك صلاحية لعرض سجل تعديلات نقطة البيع.",
    adjustmentType: "نوع التعديل",
    allTypes: "جميع الأنواع",
    logDate: "تاريخ السجل",
    orNo: "رقم الإيصال",
    originalOrDate: "تاريخ الإيصال الأصلي",
    transactionNo: "رقم العملية",
    cashier: "أمين الصندوق",
    approvedBy: "اعتمد بواسطة (المشغل)",
    grossAmount: "المبلغ الإجمالي",
    vatAmount: "مبلغ الضريبة",
    netAmount: "المبلغ الصافي",
    paymentMethod: "طريقة الدفع",
    reason: "السبب",
    remarks: "ملاحظات (مستنتجة)",
    derivedNote: "الملاحظات مستنتجة من العملية؛ اعتمد بواسطة يعرض المشغل الذي نفّذ التعديل.",
    unresolvedDates: "{n} صف لم يتمكن من تحديد تاريخ الإيصال الأصلي.",
    logEmptyState: "لا توجد تعديلات مسجلة لـ {outlet} بين {from} و {to}.",
  },
  tableLayout: {
    floorplanTooLarge: "حجم المخطط {size} ميجابايت؛ الحد الأقصى {max} ميجابايت",
    designerTitle: "مخطط الطاولات",
    publishToPos: "إظهار هذا المخطط في نقطة البيع",
    pickAnOutlet: "اختر منفذاً لتصميم مخططه",
    loadOutletsFailed: "تعذر تحميل المنافذ",
    loadTablesFailed: "تعذر تحميل طاولات هذا المنفذ",
    saveFailed: "تعذر حفظ {n} عنصر",
    saveSucceeded: "تم حفظ المخطط",
    floorplan: "المخطط",
    unplaced: "غير موضوعة",
    allPlaced: "تم وضع جميع الطاولات",
    shape: "الشكل",
    shapeRectangle: "مستطيل",
    shapeSquare: "مربع",
    shapeCircle: "دائرة",
    shapeEllipse: "بيضاوي",
    shapeTriangle: "مثلث",
    removeFromLayout: "إزالة من المخطط",
    selectATable: "اختر طاولة",
    blockingIssues: "{n} طاولة خارج المخطط",
    overlapWarning: "{n} زوج متداخل",
    layoutView: "عرض المخطط",
    booked: "محجوزة",
    nudge: "إزاحة",
    nudgeDown: "إزاحة 1 بكسل للأسفل",
    nudgeLeft: "إزاحة 1 بكسل لليسار",
    nudgeRight: "إزاحة 1 بكسل لليمين",
    nudgeUp: "إزاحة 1 بكسل للأعلى",
  },
  waiterPin: {
    dialogTitle: "يتطلب إدخال الرقم السري المصرح به",
    pinLabel: "رمز المشرف",
    verify: "تحقق",
    invalidPin: "رمز سري غير صالح. حاول مرة أخرى.",
    unauthorizedAction: "المستخدم المرتبط بهذا النادل ليس لديه إذن لتنفيذ هذا الإجراء.",
    linkedUser: "المستخدم المرتبط",
    pinFieldLabel: "رقم التعريف الشخصي",
    pinFieldHint: "رقم سري من 4-8 أرقام. اتركه فارغًا عند التعديل للاحتفاظ بالرقم الحالي.",
    associatedUserLabel: "المستخدم المرتبط",
    clearPinLabel: "مسح الرقم السري الحالي",
    authorizedWaiter: "النادل المعتمد",
    authorizedUser: "مستخدم مخول",
    voidAuthorizedWaiter: "إلغاء النادل المعتمد",
    voidAuthorizedUser: "مستخدم مفوض ملغى",
  },
  localVoidDocumentFilter: {
    showCreditMemoVoidOnly: "عرض إشعارات الدائن / الإلغاء فقط",
    chooseMode: "اختر طلبات الإلغاء / إشعار الدائن المراد عرضها",
    reversalDocuments: "مستندات العكس",
    originalOrders: "الطلبات الأصلية",
    both: "كلاهما",
    columnHeader: "دور الإلغاء / إشعار الدائن",
    roleReversal: "مستند عكس",
    roleOriginal: "طلب أصلي",
  },
};
